import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { HostListener, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import writeXlsxFile, { Feature, Sheet, SheetData } from 'write-excel-file/browser';

interface Company {
    id: string;
    researchId: string;
    companyName: string;
    foundedYear: string;
    smeStatus: string;
    ventureStatus: string;
    listingStatus: string;
    listingMarket: string;
    companyType: string;
    companyTypeSourceUrl: string;
    region: string;
    location: string;
    headquartersAddress: string;
    industry: string;
    industryDetail: string;
    coreTechnology: string;
    mainProduct: string;
    targetDisease: string;
    productType: string;
    developmentStage: string;
    developmentStatus: string;
    regulatoryStatus: string;
    officialHomepage: string;
    sourceName: string;
    sourceUrl: string;
    sourceCheckedAt: string;
    followUpItems: string;
    selectionStatus: string;
    selectionReason: string;
    sourceReliability: string;
    dataCompleteness: string;
    crossCheckSourceUrl: string;
    additionalSourceUrl1: string;
    additionalSourceUrl2: string;
    sourceAccessStatus: string;
    technologyMechanism: string;
    technologyApplications: string;
    technologyDifferentiation: string;
    technologyPerformance: string;
    technologyEvidence: string;
    technologyClaimBoundary: string;
    productCount: number;
    productStageSummary: string;
    productRegulatorySummary: string;
    fundingSummary: string;
    mainBusiness: string;
    commercializationStage: string;
    screeningClassification: string;
    screeningClassificationBasis: string;
    researchSourceIds: string[];
    researchCheckedAt: string;
    researchFollowUpItems: string;
}

interface ProductRecord {
    productId: string;
    companyId: string;
    researchCompanyId: string;
    companyName: string;
    productName: string;
    technologyMechanism: string;
    applicationArea: string;
    differentiation: string;
    performanceEvidence: string;
    ipEvidence: string;
    claimBoundary: string;
    purpose: string;
    targetCondition: string;
    developmentStageRaw: string;
    stageAsOf: string;
    regulatoryCountry: string;
    regulatoryAgency: string;
    regulatoryType: string;
    regulatoryName: string;
    regulatoryNumber: string;
    regulatoryDate: string;
    regulatoryStatus: string;
    sourceIds: string[];
    sourceUrls: string[];
    followUpItems: string;
}

interface InvestmentRecord {
    investmentId: string;
    companyId: string;
    researchCompanyId: string;
    companyName: string;
    announcementDate: string;
    actualInvestmentDate: string;
    round: string;
    roundAmountValue: number | null;
    currency: string | null;
    amountUnit: string | null;
    roundAmountRaw: string | null;
    investors: string;
    cumulativeAmountValue: number | null;
    cumulativeCurrency: string | null;
    cumulativeUnit: string | null;
    cumulativeAmountRaw: string | null;
    valuationValue: number | null;
    valuationCurrency: string | null;
    valuationUnit: string | null;
    valuationRaw: string | null;
    fundingType: string;
    fundingTypeRaw: string;
    deduplicationNote: string;
    availabilityStatus: string;
    sourceIds: string[];
    sourceUrls: string[];
}

interface ClassificationRecord {
    companyId: string;
    researchCompanyId: string;
    companyName: string;
    foundedYear: string;
    headquarters: string;
    listingStatus: string;
    listingMarket: string;
    smeStatus: string;
    ventureStatus: string;
    officialCompanyType: string;
    officialQualificationUrl: string;
    mainBusiness: string;
    commercializationStage: string;
    screeningClassification: string;
    screeningBasis: string;
    startupAssessment: string;
    classificationAsOf: string;
    sourceIds: string[];
    additionalSourceUrls: string[];
    followUpItems: string;
}

interface SourceRecord {
    sourceId: string;
    provenance: string;
    companyId: string;
    researchCompanyId: string;
    companyName: string;
    category: string;
    linkedTargetIds: string[];
    title: string;
    publisher: string;
    sourceType: string;
    publicationDate: string;
    checkedAt: string;
    url: string;
    sourceUrls: string[];
    accessResult: string;
    evidenceSummary: string;
    evidenceType: string;
    reliability: string;
}

interface ChangeRecord {
    changeId: string;
    scope: 'company' | 'global';
    companyId: string | null;
    researchCompanyId: string | null;
    companyName: string;
    category: string;
    field: string;
    previousValue: string | null;
    newValue: string;
    reason: string;
    sourceIds: string[];
    status: string;
    followUpItems: string;
    dashboardSuggestion: string;
}

interface IdMapRecord {
    id: string;
    researchId: string;
    companyName: string;
    officialHomepage: string;
    homepageHost: string;
    matchedBy: string[];
}

interface DataManifest {
    schemaVersion: string;
    inputFile: string;
    inputSha256: string;
    generatedAt: string;
    rowCounts: Record<string, number>;
    outputFiles: Record<string, string> | string[];
    validation: Record<string, unknown>;
}

interface AuthUser {
    id: string;
    username: string;
    email: string;
    name: string;
    role: 'USER' | 'ADMIN';
}

interface ReviewRecord {
    companyId: string;
    favorite: boolean;
    status: ReviewStatus;
    memo: string;
    version: number;
    createdAt: string;
    updatedAt: string;
}

type ReviewStatus = '검토 전' | '검토 중' | '추가 확인' | '검토 완료';
type AuthView = 'login' | 'register' | 'forgot' | 'reset';
type MyReviewTab = 'favorites' | 'all';
type MyReviewSort = 'updated' | 'company';

interface StageCount {
    label: string;
    count: number;
}

interface ActiveCondition {
    key: FilterKey | 'search';
    label: string;
    value: string;
}

interface SourceLink {
    label: string;
    url: string;
}

interface HyperlinkCell {
    label: string;
    url: string;
}

type ExportValue = string | number | null | HyperlinkCell;

interface ExportSheet {
    name: string;
    headers: string[];
    rows: ExportValue[][];
    widths: number[];
}

type SortKey = 'companyName' | 'industry' | 'region' | 'developmentStage';
type SortDirection = 'asc' | 'desc';
type FilterKey = 'industry'
    | 'productType'
    | 'region'
    | 'developmentStage'
    | 'listingStatus'
    | 'fundingType'
    | 'businessStage'
    | 'productStage'
    | 'regulatoryCategory';
type ExportFormat = 'xlsx' | 'csv';
type ExportScope = 'search' | 'comparison';
type ExportTarget = `${ExportScope}-${ExportFormat}`;

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
@charset "UTF-8";
:host {
  display: block;
  min-height: 100%;
  color: #172033;
  background: #f4f7fb;
}

.bio-app {
  min-height: 100vh;
  padding-bottom: 104px;
}

.shell {
  width: min(100% - 48px, 1360px);
  margin: 0 auto;
}

.topbar {
  height: 68px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid #e3e9f2;
  position: sticky;
  top: 0;
  z-index: 40;
  backdrop-filter: blur(12px);
}

.topbar-inner, .brand, .brand-mark, .topbar-meta, .hero-heading, .dataset-pill, .filter-heading, .filter-heading > div, .selection-counter, .company-heading, .summary-title, .compare-dock, .compare-dock > div, .dock-actions, .comparison-header, .detail-header, .source-box > div {
  display: flex;
  align-items: center;
}

.topbar-inner, .hero-heading, .filter-heading, .company-heading, .comparison-header, .detail-header, .compare-dock {
  justify-content: space-between;
}

.brand {
  gap: 12px;
  color: #0b2451;
}

.brand-mark {
  width: 38px;
  height: 38px;
  justify-content: center;
  border-radius: 11px;
  color: white;
  font-size: 18px;
  background: linear-gradient(135deg, #113d7a, #2478d3);
  box-shadow: 0 6px 14px rgba(16, 63, 123, 0.22);
}

.brand-copy {
  display: flex;
  flex-direction: column;
  line-height: 1.05;
}

.brand-copy strong {
  font-size: 20px;
  letter-spacing: -0.4px;
}

.brand-copy small {
  margin-top: 5px;
  color: #7b8799;
  font-size: 9px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.topbar-meta {
  gap: 7px;
  color: #647186;
  font-size: 12px;
  font-weight: 600;
}

.update-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #35a978;
  box-shadow: 0 0 0 4px #e5f7ef;
}

.hero {
  color: white;
  background: radial-gradient(circle at 78% 0, rgba(49, 132, 226, 0.35), transparent 35%), linear-gradient(120deg, #0b2348, #103c77 66%, #155397);
  padding: 48px 0 58px;
}

.hero h1 {
  margin: 8px 0 10px;
  font-size: 32px;
  line-height: 1.3;
  letter-spacing: -1.3px;
}

.eyebrow {
  margin: 0;
  color: #65b9ff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1.5px;
}

.hero-description {
  margin: 0;
  color: #c3d3e9;
  font-size: 14px;
}

.dataset-pill {
  gap: 7px;
  align-self: flex-start;
  padding: 8px 12px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.09);
  color: #dbeafe;
  font-size: 11px;
  font-weight: 700;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 13px;
  max-width: 850px;
  height: 58px;
  margin-top: 30px;
  padding: 0 20px;
  background: white;
  border-radius: 12px;
  color: #6c7d93;
  box-shadow: 0 14px 32px rgba(4, 21, 51, 0.3);
}

.search-box > i {
  color: #2369bd;
  font-size: 17px;
}

.search-box input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #18243a;
  font-size: 15px;
}

.search-box input::placeholder {
  color: #929eb0;
}

.search-clear {
  border: 0;
  background: none;
  color: #a2acba;
  font-size: 16px;
}

.page-content {
  margin-top: -24px;
}

.data-notice {
  display: flex;
  gap: 12px;
  padding: 14px 18px;
  border: 1px solid #cfe1f6;
  border-radius: 10px;
  background: #f0f7ff;
  color: #24558b;
  box-shadow: 0 5px 18px rgba(18, 47, 85, 0.06);
}

.data-notice > i {
  margin-top: 2px;
  color: #2876c7;
}

.data-notice strong {
  display: block;
  font-size: 13px;
}

.data-notice p {
  margin: 3px 0 0;
  color: #587798;
  font-size: 11px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) 1.8fr;
  gap: 13px;
  margin: 18px 0;
}

.summary-card {
  min-height: 108px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px;
  border: 1px solid #e1e7ef;
  border-radius: 12px;
  background: white;
  box-shadow: 0 5px 18px rgba(20, 45, 80, 0.04);
}

.summary-icon {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  flex: 0 0 auto;
  border-radius: 11px;
}

.summary-icon.blue {
  color: #2668bb;
  background: #eaf3ff;
}

.summary-icon.teal {
  color: #16877f;
  background: #e7f7f5;
}

.summary-icon.violet {
  color: #7557bf;
  background: #f0edfc;
}

.summary-card span {
  display: block;
  color: #6c788a;
  font-size: 11px;
  font-weight: 600;
}

.summary-card strong {
  margin-right: 3px;
  color: #12233f;
  font-size: 25px;
}

.summary-card small {
  color: #8993a2;
  font-size: 10px;
}

.stage-summary {
  display: block;
}

.summary-title {
  color: #69768a;
  font-size: 11px;
  font-weight: 700;
}

.summary-title i {
  color: #8da0b9;
}

.stage-counts {
  display: flex;
  gap: 8px;
  margin-top: 15px;
  overflow-x: auto;
}

.stage-counts span {
  min-width: 48px;
  padding-right: 8px;
  border-right: 1px solid #edf0f4;
  white-space: nowrap;
  font-size: 9px;
}

.stage-counts span:last-child {
  border: 0;
}

.stage-counts b {
  display: block;
  margin-bottom: 3px;
  color: #15345e;
  font-size: 16px;
}

.workspace {
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 16px;
  align-items: start;
}

.filter-panel, .company-panel, .comparison-section {
  border: 1px solid #dfe6ef;
  border-radius: 13px;
  background: white;
  box-shadow: 0 5px 20px rgba(21, 46, 80, 0.04);
}

.filter-panel {
  position: sticky;
  top: 86px;
  overflow: hidden;
}

.filter-heading {
  height: 58px;
  padding: 0 17px;
  border-bottom: 1px solid #e8edf3;
}

.filter-heading > div {
  gap: 8px;
}

.filter-heading h2 {
  margin: 0;
  color: #18263c;
  font-size: 14px;
}

.filter-heading > div > i {
  color: #2468b7;
}

.filter-heading > div > span {
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  color: white;
  background: #2871c1;
  font-size: 9px;
}

.filter-heading button {
  border: 0;
  background: none;
  color: #4774a9;
  font-size: 10px;
}

.filter-heading button:disabled {
  color: #b0b8c3;
  cursor: default;
}

.filter-groups {
  padding: 5px 16px 15px;
}

.filter-group {
  display: block;
  margin-top: 15px;
}

.filter-group > span {
  display: block;
  margin-bottom: 7px;
  color: #3f4d62;
  font-size: 10px;
  font-weight: 700;
}

.filter-group select {
  width: 100%;
  height: 38px;
  padding: 0 30px 0 10px;
  border: 1px solid #d8e0e9;
  border-radius: 7px;
  outline: 0;
  background: white;
  color: #354257;
  font-size: 11px;
}

.filter-group select:focus {
  border-color: #3c7fc8;
  box-shadow: 0 0 0 3px #e7f1fc;
}

.filter-tip {
  display: flex;
  gap: 8px;
  margin: 0 12px 14px;
  padding: 11px;
  border-radius: 8px;
  color: #687891;
  background: #f5f8fc;
}

.filter-tip i {
  color: #d59a29;
}

.filter-tip p {
  margin: 0;
  font-size: 9px;
  line-height: 1.55;
}

.company-panel {
  min-width: 0;
  overflow: visible;
}

.company-heading {
  min-height: 70px;
  padding: 0 20px;
  border-bottom: 1px solid #e7ecf2;
  border-radius: 13px 13px 0 0;
}

.company-heading h2 {
  display: inline;
  margin: 0 8px 0 0;
  color: #16253c;
  font-size: 17px;
}

.company-heading p {
  display: inline;
  margin: 0;
  color: #8691a1;
  font-size: 10px;
}

.selection-counter {
  gap: 6px;
  padding: 7px 10px;
  border: 1px solid #e1e7ef;
  border-radius: 7px;
  color: #7c8798;
  background: #fafbfd;
  font-size: 10px;
}

.selection-counter.has-selection {
  border-color: #b9d5f3;
  color: #1e5d9f;
  background: #edf6ff;
}

.selection-counter strong {
  font-size: 13px;
}

.selection-notice {
  margin: 12px 16px 0;
  padding: 9px 12px;
  border-radius: 7px;
  color: #9b5a0b;
  background: #fff6df;
  font-size: 11px;
}

.table-wrap {
  overflow-x: auto;
}

.company-table {
  width: 100%;
  min-width: 880px;
  border-collapse: collapse;
  table-layout: fixed;
}

.company-table th {
  padding: 11px 10px;
  color: #718096;
  background: #f8fafc;
  font-size: 9px;
  font-weight: 700;
  text-align: left;
}

.company-table td {
  padding: 15px 10px;
  border-top: 1px solid #edf0f4;
  color: #3b495d;
  font-size: 11px;
  line-height: 1.45;
  vertical-align: middle;
}

.company-table tbody tr {
  cursor: pointer;
  transition: 0.16s;
}

.company-table tbody tr:hover {
  background: #f7fbff;
}

.company-table tbody tr.selected {
  background: #f0f7ff;
}

.company-table tbody tr:focus-visible {
  outline: 2px solid #397bc1;
  outline-offset: -2px;
}

.company-table th:nth-child(2) {
  width: 170px;
}

.company-table th:nth-child(3) {
  width: 170px;
}

.company-table th:nth-child(4) {
  width: 145px;
}

.company-table th:nth-child(5) {
  width: 115px;
}

.company-table th:nth-child(6) {
  width: 90px;
}

.select-cell {
  width: 50px;
  text-align: center !important;
}

.detail-cell {
  width: 48px;
  text-align: center !important;
}

.detail-cell button {
  width: 28px;
  height: 28px;
  border: 1px solid #dce3ec;
  border-radius: 7px;
  color: #627087;
  background: white;
}

.check-control {
  display: inline-grid;
  place-items: center;
  cursor: pointer;
}

.check-control input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.check-control span {
  width: 18px;
  height: 18px;
  display: grid;
  place-items: center;
  border: 1.5px solid #c6d0dd;
  border-radius: 5px;
  background: white;
}

.check-control input:focus-visible + span {
  outline: 2px solid #397bc1;
  outline-offset: 2px;
}

.check-control input:checked + span {
  border-color: #236bbd;
  background: #236bbd;
}

.check-control input:checked + span:after {
  content: "✓";
  color: white;
  font-size: 11px;
  font-weight: 900;
}

.company-name, .product-name {
  display: block;
  color: #182840;
  font-size: 11px;
}

.industry-tag {
  display: inline-block;
  margin-top: 5px;
  padding: 3px 7px;
  border-radius: 4px;
  color: #316ba7;
  background: #edf5fd;
  font-size: 9px;
}

.company-location {
  display: block;
  margin-top: 5px;
  color: #8692a2;
  font-size: 9px;
}

.product-name + small {
  display: block;
  margin-top: 3px;
  color: #8793a3;
  font-size: 9px;
}

.stage-badge {
  display: inline-block;
  padding: 4px 7px;
  border: 1px solid;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 700;
  white-space: nowrap;
}

.stage-research {
  color: #6c58a8;
  background: #f3efff;
  border-color: #ddd4f5;
}

.stage-preclinical {
  color: #5e6e86;
  background: #f1f4f8;
  border-color: #dce2ea;
}

.stage-phase-one {
  color: #1f7298;
  background: #e9f7fc;
  border-color: #c3e5f1;
}

.stage-phase-two {
  color: #156f65;
  background: #e7f7f3;
  border-color: #bae5dc;
}

.stage-phase-three {
  color: #a35818;
  background: #fff1e5;
  border-color: #f0ceb1;
}

.stage-review {
  color: #a5640e;
  background: #fff6df;
  border-color: #f2ddb0;
}

.stage-commercial {
  color: #2c6b35;
  background: #edf8ee;
  border-color: #cce6cf;
}

.stage-default {
  color: #5f6b7a;
  background: #f4f5f7;
  border-color: #dfe3e8;
}

.state-box {
  min-height: 300px;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 10px;
  color: #8190a3;
  text-align: center;
}

.state-box > i {
  color: #397ac0;
  font-size: 24px;
}

.state-box p {
  margin: 0;
  font-size: 12px;
}

.state-box button {
  padding: 8px 12px;
  border: 1px solid #cdd9e8;
  border-radius: 7px;
  color: #2764a4;
  background: white;
  font-size: 10px;
}

.state-box.error > i {
  color: #d78533;
}

.mobile-list {
  display: none;
}

.comparison-section {
  margin-top: 18px;
  scroll-margin-top: 85px;
  overflow: hidden;
}

.comparison-header {
  padding: 20px 22px;
  border-bottom: 1px solid #e4eaf1;
}

.comparison-header h2 {
  margin: 4px 0;
  font-size: 18px;
}

.comparison-header > div > p:last-child {
  margin: 0;
  color: #79869a;
  font-size: 10px;
}

.clear-all {
  padding: 8px 11px;
  border: 1px solid #dce3ec;
  border-radius: 7px;
  color: #5e6c80;
  background: white;
  font-size: 10px;
}

.comparison-scroll {
  overflow-x: auto;
}

.comparison-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.comparison-table th, .comparison-table td {
  padding: 14px 16px;
  border-right: 1px solid #e9edf2;
  border-bottom: 1px solid #e9edf2;
  color: #405066;
  font-size: 11px;
  text-align: left;
  vertical-align: top;
}

.comparison-table th:first-child {
  width: 180px;
  color: #536176;
  background: #f7f9fc;
}

.comparison-table thead th {
  position: relative;
  color: #172941;
  background: #f1f6fc;
}

.comparison-table thead th > span {
  display: block;
  margin-bottom: 5px;
  color: #4a83bd;
  font-size: 8px;
  text-transform: uppercase;
}

.comparison-table thead th > strong {
  display: block;
  padding-right: 22px;
  font-size: 11px;
}

.comparison-table thead button {
  position: absolute;
  top: 12px;
  right: 10px;
  width: 22px;
  height: 22px;
  border: 0;
  border-radius: 5px;
  color: #77859a;
  background: #e1e9f3;
}

.compare-dock {
  position: fixed;
  z-index: 35;
  left: 50%;
  bottom: 18px;
  width: min(100% - 40px, 700px);
  min-height: 68px;
  padding: 10px 12px 10px 16px;
  transform: translateX(-50%);
  border: 1px solid rgba(130, 164, 201, 0.5);
  border-radius: 14px;
  color: white;
  background: rgba(10, 38, 76, 0.96);
  box-shadow: 0 16px 40px rgba(9, 27, 55, 0.3);
  backdrop-filter: blur(12px);
}

.compare-dock > div:first-child {
  gap: 11px;
}

.dock-count {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  background: #2d7dce;
  font-size: 14px;
  font-weight: 800;
}

.compare-dock p {
  margin: 0;
}

.compare-dock p strong, .compare-dock p small {
  display: block;
}

.compare-dock p strong {
  font-size: 11px;
}

.compare-dock p small {
  margin-top: 3px;
  color: #aebfd4;
  font-size: 9px;
}

.dock-actions {
  gap: 8px;
}

.dock-actions button {
  height: 38px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 700;
}

.dock-clear {
  border: 0;
  color: #becbdd;
  background: transparent;
}

.dock-primary {
  border: 0;
  color: #12325a;
  background: white;
}

.dock-primary i {
  margin-left: 8px;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(6, 20, 40, 0.58);
  backdrop-filter: blur(4px);
}

.detail-modal {
  width: min(100%, 760px);
  max-height: min(820px, 100vh - 40px);
  overflow: auto;
  border-radius: 16px;
  background: white;
  box-shadow: 0 28px 70px rgba(3, 18, 39, 0.32);
}

.detail-header {
  padding: 24px 26px;
  color: white;
  background: linear-gradient(120deg, #0c2b55, #155698);
}

.detail-header p {
  margin: 8px 0 2px;
  color: #bcd3ec;
  font-size: 11px;
}

.detail-header h2 {
  margin: 0;
  font-size: 21px;
}

.verified-label {
  padding: 4px 7px;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 5px;
  color: #d9ecff;
  background: rgba(255, 255, 255, 0.1);
  font-size: 8px;
  font-weight: 800;
}

.detail-header button {
  width: 34px;
  height: 34px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 8px;
  color: white;
  background: rgba(255, 255, 255, 0.08);
}

.detail-body {
  padding: 22px 26px;
}

.detail-highlight {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.detail-highlight > div {
  padding: 14px;
  border: 1px solid #e1e8f1;
  border-radius: 9px;
  background: #f8fafc;
}

.detail-highlight span {
  display: block;
  margin-bottom: 6px;
  color: #77869a;
  font-size: 9px;
}

.detail-highlight strong:not(.stage-badge) {
  color: #1e334e;
  font-size: 12px;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  margin: 20px 0;
  border-top: 1px solid #e5eaf1;
}

.detail-grid > div {
  padding: 15px 5px;
  border-bottom: 1px solid #e5eaf1;
}

.detail-grid > div:nth-child(odd) {
  margin-right: 16px;
}

.detail-grid dt, .source-box dt {
  margin-bottom: 5px;
  color: #7d899a;
  font-size: 9px;
  font-weight: 700;
}

.detail-grid dd, .source-box dd {
  margin: 0;
  color: #27374e;
  font-size: 11px;
  line-height: 1.5;
}

.source-box {
  padding: 16px;
  border: 1px solid #d9e7f5;
  border-radius: 10px;
  background: #f2f7fc;
}

.source-box > div {
  gap: 8px;
  color: #245d99;
}

.source-box h3 {
  margin: 0;
  font-size: 11px;
}

.source-box > dl {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px 18px;
  margin: 13px 0;
}

.source-box dl > div {
  min-width: 0;
}

.source-box a {
  color: #1c5f9f;
  text-decoration: none;
}

.source-box a:hover {
  text-decoration: underline;
}

.source-box a i {
  margin-left: 6px;
  font-size: 8px;
}

.source-links {
  display: grid;
  gap: 7px;
  margin: 14px 0 0;
  padding: 12px 0 0;
  border-top: 1px solid #d9e3ee;
  list-style: none;
}

.source-links a {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  font-size: 10px;
  line-height: 1.45;
}

.source-links a span {
  overflow-wrap: anywhere;
}

.verification-note {
  display: block !important;
  margin-top: 14px;
  padding: 11px 12px;
  border-radius: 8px;
  color: #79571b !important;
  background: #fff8e8;
}

.verification-note strong {
  display: block;
  font-size: 9px;
}

.verification-note p {
  margin: 4px 0 0;
  color: #8d6a2e;
  font-size: 9px;
  line-height: 1.5;
}

.detail-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 15px 26px;
  border-top: 1px solid #e6ebf1;
  background: #fafbfd;
}

.detail-footer button {
  min-width: 92px;
  height: 38px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 700;
}

.detail-footer .secondary {
  border: 1px solid #d7dfe9;
  color: #5d6b7e;
  background: white;
}

.detail-footer .primary {
  border: 0;
  color: white;
  background: #1f65ad;
}

.detail-footer .primary i {
  margin-right: 7px;
}

@media (max-width: 1100px) {
  .summary-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .stage-summary {
    grid-column: 1/-1;
  }
  .workspace {
    grid-template-columns: 1fr;
  }
  .filter-panel {
    position: static;
  }
  .filter-groups {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }
  .filter-tip {
    display: none;
  }
  .filter-group {
    margin-top: 10px;
  }
}
@media (max-width: 760px) {
  .shell {
    width: min(100% - 28px, 1360px);
  }
  .topbar {
    height: 60px;
  }
  .topbar-meta, .dataset-pill {
    display: none;
  }
  .hero {
    padding: 32px 0 48px;
  }
  .hero h1 {
    font-size: 25px;
  }
  .hero-description {
    font-size: 12px;
  }
  .search-box {
    height: 52px;
    margin-top: 22px;
    padding: 0 15px;
  }
  .search-box input {
    font-size: 12px;
  }
  .page-content {
    margin-top: -18px;
  }
  .data-notice {
    padding: 12px;
  }
  .data-notice p {
    line-height: 1.5;
  }
  .summary-grid {
    grid-template-columns: 1fr 1fr;
  }
  .summary-card {
    min-height: 92px;
    padding: 13px;
  }
  .stage-summary {
    grid-column: 1/-1;
  }
  .filter-groups {
    grid-template-columns: 1fr 1fr;
  }
  .company-heading {
    padding: 12px 14px;
    align-items: flex-start;
    gap: 10px;
  }
  .company-heading p {
    display: block;
    margin-top: 3px;
  }
  .desktop-list {
    display: none;
  }
  .mobile-list {
    display: grid;
    gap: 10px;
    padding: 12px;
  }
  .company-card {
    padding: 15px;
    border: 1px solid #e2e8ef;
    border-radius: 10px;
    background: white;
  }
  .company-card.selected {
    border-color: #78aee2;
    background: #f4f9ff;
  }
  .company-card-top, .company-card-bottom {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
  }
  .company-card h3 {
    margin: 7px 0 0;
    font-size: 13px;
  }
  .company-card dl {
    margin: 14px 0;
  }
  .company-card dl > div {
    display: grid;
    grid-template-columns: 72px 1fr;
    padding: 6px 0;
    border-top: 1px solid #edf0f4;
  }
  .company-card dt {
    color: #8390a2;
    font-size: 9px;
  }
  .company-card dd {
    margin: 0;
    color: #35455a;
    font-size: 10px;
  }
  .company-card-bottom {
    align-items: center;
  }
  .company-card-bottom button {
    border: 0;
    color: #2869ad;
    background: none;
    font-size: 10px;
  }
  .comparison-header {
    align-items: flex-start;
    padding: 17px;
  }
  .clear-all {
    white-space: nowrap;
  }
  .comparison-table th:first-child {
    width: 120px;
  }
  .compare-dock {
    bottom: 10px;
    width: calc(100% - 20px);
  }
  .dock-clear {
    display: none;
  }
  .detail-modal {
    max-height: calc(100vh - 24px);
  }
  .detail-header, .detail-body {
    padding: 20px;
  }
  .detail-highlight, .detail-grid {
    grid-template-columns: 1fr;
  }
  .detail-grid > div:nth-child(odd) {
    margin-right: 0;
  }
  .source-box > dl {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .detail-footer {
    padding: 12px 20px;
  }
}
@media (max-width: 430px) {
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .stage-summary {
    grid-column: auto;
  }
  .filter-groups {
    grid-template-columns: 1fr;
  }
  .brand-copy small {
    display: none;
  }
  .selection-counter span {
    display: none;
  }
  .compare-dock p {
    display: none;
  }
  .dock-primary {
    padding: 0 11px !important;
  }
}
.check-control input:disabled + span {
  border-color: #e2e6ec;
  background: #f3f5f7;
  cursor: not-allowed;
}

/* Search result controls */
.list-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 14px 18px;
  border-bottom: 1px solid #e7ecf2;
  background: #fbfcfe;
}

.condition-area {
  min-width: 0;
  flex: 1;
}

.condition-meta {
  display: flex;
  align-items: center;
  gap: 9px;
  min-height: 28px;
}

.condition-meta strong {
  color: #173457;
  font-size: 12px;
}

.condition-meta span {
  padding-left: 9px;
  border-left: 1px solid #dce3eb;
  color: #7a8799;
  font-size: 9px;
}

.condition-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 7px;
}

.condition-tags button {
  display: flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  padding: 5px 8px;
  border: 1px solid #cfe0f2;
  border-radius: 999px;
  color: #315d8c;
  background: #edf6ff;
  font-size: 9px;
}

.condition-tags button:hover {
  border-color: #8fbae5;
  background: #e2f0fe;
}

.condition-tags button span {
  color: #6b86a2;
}

.condition-tags button strong {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 9px;
}

.condition-tags button i {
  margin-left: 2px;
  color: #5680aa;
}

.list-actions, .comparison-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
}

.list-actions {
  min-width: 0;
  overflow: visible;
}

.sort-controls {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: visible;
}

.sort-controls-label {
  flex: 0 0 auto;
  color: #738095;
  font-size: 9px;
  white-space: nowrap;
}

.sort-control {
  min-width: 0;
  display: block;
  flex: 0 0 auto;
}

.sort-control select {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  padding: 0 32px 0 11px;
  border: 1px solid #d8e0e9;
  border-radius: 7px;
  outline: 0;
  color: #263b57;
  background-color: white;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
  text-overflow: clip;
}

.sort-control select:focus {
  border-color: #3c7fc8;
  box-shadow: 0 0 0 3px #e7f1fc;
}

.sort-field-control {
  min-width: 132px;
}

.sort-direction-control {
  min-width: 120px;
}

.excel-button {
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 11px;
  border: 1px solid #d6e0eb;
  border-radius: 7px;
  color: #1f659f;
  background: white;
  font-size: 9px;
  font-weight: 700;
  white-space: nowrap;
}

.excel-button:hover:not(:disabled) {
  border-color: #9dbdde;
  color: #1d5f9f;
  background: #f4f9ff;
}

.excel-button i {
  color: #23835f;
  font-size: 12px;
}

.excel-button:disabled {
  color: #a8b1bd;
  background: #f5f6f8;
  cursor: not-allowed;
}

.excel-button:disabled i {
  color: #a8b1bd;
}

.empty-state {
  min-height: 330px;
  padding: 40px 20px;
}

.empty-state .empty-icon {
  width: 54px;
  height: 54px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #5b88b6;
  background: #edf5fd;
  font-size: 19px;
}

.empty-state h3 {
  margin: 2px 0 0;
  color: #253b57;
  font-size: 14px;
}

.empty-state p {
  margin: 0;
  color: #7d8a9c;
  font-size: 10px;
  line-height: 1.7;
}

.empty-state button {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 5px;
  color: #1e5f9e;
  font-weight: 700;
}

/* Sticky comparison matrix and difference cues */
.comparison-actions {
  align-items: center;
}

.comparison-scroll {
  max-height: 520px;
  overflow: auto;
  isolation: isolate;
  scrollbar-gutter: stable;
}

.comparison-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  box-shadow: 0 1px 0 #dce4ed;
}

.comparison-table thead th:first-child {
  left: 0;
  z-index: 5;
  background: #e9f1fa;
}

.comparison-table tbody th {
  position: sticky;
  left: 0;
  z-index: 3;
  background: #f7f9fc;
  box-shadow: 1px 0 0 #e1e7ee;
}

.comparison-table tbody th > span {
  display: block;
  color: #45566d;
  font-weight: 700;
}

.comparison-table tbody th > small {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 6px;
  border-radius: 999px;
  color: #9a620f;
  background: #fff0c8;
  font-size: 8px;
  font-weight: 800;
}

.comparison-table tbody tr.is-different td {
  background: #fffaf0;
}

.comparison-table tbody tr.is-different td:nth-child(even) {
  background: #fff7e7;
}

.comparison-table tbody tr.is-different td {
  box-shadow: inset 0 2px 0 rgba(225, 168, 66, 0.12);
}

/* Selection limit alert */
.limit-toast {
  position: fixed;
  z-index: 80;
  top: 82px;
  right: 24px;
  width: min(100% - 32px, 430px);
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: start;
  gap: 11px;
  padding: 14px 14px;
  border: 1px solid #f0c982;
  border-radius: 11px;
  color: #644417;
  background: #fffaf0;
  box-shadow: 0 16px 38px rgba(77, 51, 12, 0.2);
}

.limit-toast-icon {
  width: 34px;
  height: 34px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #aa6b0d;
  background: #ffedc3;
}

.limit-toast strong {
  display: block;
  color: #71470b;
  font-size: 11px;
}

.limit-toast p {
  margin: 4px 0 0;
  color: #8b651f;
  font-size: 9px;
  line-height: 1.5;
}

.limit-toast > button {
  width: 26px;
  height: 26px;
  border: 0;
  border-radius: 6px;
  color: #9c7a45;
  background: transparent;
}

@media (max-width: 900px) {
  .list-toolbar {
    flex-direction: column;
  }
  .list-actions {
    width: 100%;
    flex-wrap: nowrap;
  }
  .comparison-header {
    gap: 14px;
  }
  .comparison-actions {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}
@media (max-width: 760px) {
  .list-toolbar {
    padding: 12px 14px;
    gap: 12px;
  }
  .condition-meta {
    justify-content: space-between;
  }
  .condition-tags button strong {
    max-width: 150px;
  }
  .list-actions {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }
  .sort-controls {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
  }
  .sort-controls-label {
    font-size: 10px;
    font-weight: 700;
  }
  .sort-control, .sort-field-control, .sort-direction-control {
    width: 100%;
    min-width: 0;
  }
  .list-actions > .excel-button {
    width: 100%;
  }
  .comparison-header {
    flex-direction: column;
  }
  .comparison-actions {
    width: 100%;
    justify-content: flex-start;
  }
  .comparison-actions .excel-button {
    width: auto;
  }
  .comparison-scroll {
    max-height: 460px;
  }
  .comparison-table tbody th {
    min-width: 120px;
  }
  .limit-toast {
    top: 70px;
    right: 16px;
  }
  .company-heading p {
    line-height: 1.5;
  }
}
@media (max-width: 430px) {
  .condition-tags button strong {
    max-width: 110px;
  }
  .comparison-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .comparison-actions button {
    width: 100%;
    justify-content: center;
  }
  .limit-toast {
    right: 10px;
    width: calc(100% - 20px);
  }
}
/* Review readability improvements */
.brand-copy small {
  font-size: 11px;
}

.eyebrow {
  font-size: 12px;
}

.dataset-pill {
  font-size: 13px;
}

.data-notice strong {
  font-size: 14px;
  line-height: 1.45;
}

.data-notice p {
  color: #486b91;
  font-size: 13px;
  line-height: 1.55;
}

.summary-card span,
.summary-title {
  color: #55657a;
  font-size: 13px;
}

.summary-card small {
  color: #68778a;
  font-size: 12px;
}

.stage-counts span {
  min-width: 62px;
  font-size: 11px;
}

.workspace {
  grid-template-columns: 240px minmax(0, 1fr);
}

.filter-heading h2 {
  font-size: 16px;
}

.filter-heading > div > span,
.filter-heading button {
  font-size: 12px;
}

.filter-group > span {
  font-size: 13px;
}

.filter-group select {
  height: 42px;
  color: #26384f;
  font-size: 13px;
}

.filter-tip p {
  color: #536780;
  font-size: 12px;
}

.company-heading p {
  color: #65758a;
  font-size: 13px;
}

.selection-counter {
  color: #5f6f84;
  font-size: 12px;
}

.condition-meta strong {
  font-size: 14px;
}

.condition-meta span,
.condition-tags button,
.condition-tags button strong,
.sort-controls-label {
  font-size: 12px;
}

.sort-control select,
.excel-button {
  height: 42px;
  font-size: 13px;
}

.excel-button {
  padding: 0 14px;
}

.company-table {
  min-width: 1080px;
}

.company-table th {
  padding: 13px 12px;
  color: #56677d;
  font-size: 12px;
  line-height: 1.4;
}

.company-table td {
  padding: 17px 12px;
  color: #2f4055;
  font-size: 13px;
  line-height: 1.6;
}

.company-table th:nth-child(2) {
  width: 190px;
}

.company-table th:nth-child(3) {
  width: 205px;
}

.company-table th:nth-child(4) {
  width: 175px;
}

.company-table th:nth-child(5) {
  width: 145px;
}

.company-table th:nth-child(6) {
  width: 105px;
}

.company-name,
.product-name {
  font-size: 14px;
  line-height: 1.45;
}

.industry-tag,
.company-location,
.product-name + small,
.stage-badge {
  font-size: 11px;
}

.comparison-header > div > p:last-child,
.clear-all {
  font-size: 12px;
}

.comparison-table th,
.comparison-table td {
  color: #304258;
  font-size: 13px;
  line-height: 1.55;
}

.comparison-table thead th > span,
.comparison-table tbody th > small {
  font-size: 10px;
}

.comparison-table thead th > strong {
  font-size: 13px;
}

.compare-dock p strong {
  font-size: 13px;
}

.compare-dock p small,
.dock-actions button {
  font-size: 11px;
}

.verified-label {
  font-size: 11px;
}

.detail-header p {
  font-size: 13px;
}

.detail-highlight span,
.detail-grid dt,
.source-box dt {
  color: #5f7086;
  font-size: 12px;
}

.detail-highlight strong:not(.stage-badge),
.detail-grid dd,
.source-box dd {
  color: #1f324b;
  font-size: 14px;
  line-height: 1.6;
}

.source-box h3 {
  font-size: 14px;
}

.source-links a,
.verification-note strong,
.verification-note p {
  font-size: 12px;
}

.detail-footer button {
  font-size: 13px;
}

.limit-toast strong {
  font-size: 13px;
}

.limit-toast p {
  font-size: 12px;
}

.state-box button {
  min-height: 40px;
  font-size: 12px;
}

.empty-state h3 {
  font-size: 16px;
}

.empty-state p {
  color: #62738a;
  font-size: 13px;
}

@media (max-width: 1100px) {
  .workspace {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 760px) {
  .hero-description,
  .search-box input {
    font-size: 14px;
  }
  .company-card h3 {
    font-size: 16px;
  }
  .company-card .company-location {
    font-size: 12px;
  }
  .company-card dt {
    font-size: 12px;
  }
  .company-card dd {
    font-size: 13px;
    line-height: 1.55;
  }
  .company-card-bottom button {
    min-height: 40px;
    font-size: 13px;
  }
  .sort-controls-label {
    font-size: 13px;
  }
  .comparison-actions .excel-button {
    width: auto;
  }
}
/* Account and private review workspace */
.topbar-actions,
.detail-header-actions,
.company-name-line,
.personal-review-toolbar,
.memo-actions,
.review-tabs,
.my-review-controls,
.my-review-card-main,
.my-review-card footer {
  display: flex;
  align-items: center;
}

.topbar-actions {
  gap: 10px;
}

.login-button,
.my-review-button,
.account-button {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 8px;
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
  font-size: 12px;
  font-weight: 750;
}

.login-button:hover,
.my-review-button:hover,
.account-button:hover {
  background: rgba(255, 255, 255, 0.16);
}

.my-review-button span {
  min-width: 20px;
  padding: 2px 6px;
  border-radius: 999px;
  color: #12365e;
  background: #fff;
  font-size: 10px;
}

.account-menu-wrap {
  position: relative;
}

.account-popover {
  position: absolute;
  z-index: 90;
  top: calc(100% + 9px);
  right: 0;
  width: 220px;
  display: grid;
  gap: 5px;
  padding: 14px;
  border: 1px solid #dce5ef;
  border-radius: 10px;
  color: #243a57;
  background: #fff;
  box-shadow: 0 14px 34px rgba(5, 28, 58, 0.2);
}

.account-popover strong {
  font-size: 13px;
}

.account-popover small {
  color: #6c7b8f;
  overflow-wrap: anywhere;
}

.account-popover > span {
  width: max-content;
  margin-top: 5px;
  padding: 3px 7px;
  border-radius: 999px;
  color: #25619d;
  background: #eaf4ff;
  font-size: 10px;
  font-weight: 800;
}

.account-popover button {
  margin-top: 7px;
  padding: 8px;
  border: 1px solid #d8e1eb;
  border-radius: 7px;
  color: #40536b;
  background: #fff;
  font-weight: 700;
}

.company-name-line {
  gap: 7px;
  min-width: 0;
}

.favorite-star {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  display: inline-grid;
  place-items: center;
  padding: 0;
  border: 1px solid #d9e2ec;
  border-radius: 7px;
  color: #7a899c;
  background: #fff;
}

.favorite-star:hover:not(:disabled),
.favorite-star.active {
  border-color: #efc15a;
  color: #b97800;
  background: #fff8df;
}

.favorite-star:disabled {
  opacity: 0.55;
  cursor: wait;
}

.company-card .company-name-line {
  margin-top: 7px;
}

.company-card .company-name-line h3 {
  margin: 0;
}

.comparison-options {
  display: flex;
  align-items: center;
  gap: 8px;
}

.comparison-options label {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid #d7e1ec;
  border-radius: 8px;
  color: #38516f;
  background: #fff;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.comparison-options input {
  width: 15px;
  height: 15px;
  accent-color: #246db4;
}

.comparison-options label.disabled {
  color: #a1acb8;
  background: #f5f6f8;
}

.detail-header-actions {
  align-self: flex-start;
  gap: 7px;
}

.detail-header .detail-favorite.active {
  color: #173f6c;
  background: #ffd873;
}

.personal-review-section {
  scroll-margin-top: 20px;
  border: 1px solid #cfe0f2;
  border-radius: 12px;
  background: #f7fbff;
}

.personal-login-prompt {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border: 1px dashed #bcd2e9;
  border-radius: 10px;
  background: #fff;
}

.personal-login-prompt > i {
  width: 38px;
  height: 38px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #2668a8;
  background: #eaf4ff;
}

.personal-login-prompt strong {
  display: block;
  color: #263b56;
  font-size: 13px;
}

.personal-login-prompt p {
  margin: 4px 0 0;
  color: #6b7a8d;
  font-size: 11px;
}

.personal-login-prompt button,
.memo-save {
  min-height: 38px;
  padding: 0 14px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  background: #1e65ab;
  font-size: 12px;
  font-weight: 800;
}

.personal-review-editor {
  display: grid;
  gap: 14px;
}

.personal-review-toolbar {
  flex-wrap: wrap;
  gap: 10px;
}

.review-favorite-button {
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid #d5e0eb;
  border-radius: 8px;
  color: #4d6077;
  background: #fff;
  font-size: 12px;
  font-weight: 750;
}

.review-favorite-button i {
  margin-right: 7px;
}

.review-favorite-button.active {
  border-color: #e9bc50;
  color: #9b6500;
  background: #fff8df;
}

.review-status-field {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #53657b;
  font-size: 11px;
  font-weight: 700;
}

.review-status-field select {
  min-height: 40px;
  padding: 0 32px 0 10px;
  border: 1px solid #d4dfea;
  border-radius: 8px;
  color: #243c59;
  background: #fff;
  font-size: 12px;
}

.review-status-badge {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 3px 9px;
  border: 1px solid;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 850;
  white-space: nowrap;
}

.review-before {
  border-color: #d5dde7;
  color: #66768a;
  background: #f3f6f9;
}

.review-progress {
  border-color: #a8cbed;
  color: #1d5f9f;
  background: #eaf5ff;
}

.review-check {
  border-color: #ebca83;
  color: #936214;
  background: #fff7df;
}

.review-complete {
  border-color: #a9d7bf;
  color: #28744e;
  background: #eaf8f0;
}

.memo-field {
  display: grid;
  gap: 7px;
  color: #344b67;
  font-size: 12px;
  font-weight: 750;
}

.memo-field textarea {
  width: 100%;
  resize: vertical;
  box-sizing: border-box;
  padding: 12px;
  border: 1px solid #ccd9e6;
  border-radius: 9px;
  outline: 0;
  color: #24374f;
  background: #fff;
  font: inherit;
  font-weight: 400;
  line-height: 1.65;
}

.memo-field textarea:focus {
  border-color: #337bc1;
  box-shadow: 0 0 0 3px rgba(51, 123, 193, 0.14);
}

.memo-field small {
  justify-self: end;
  color: #738196;
  font-weight: 500;
}

.memo-actions {
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 9px;
}

.memo-actions > span {
  margin-right: auto;
  color: #718197;
  font-size: 10px;
}

.memo-delete {
  min-height: 38px;
  padding: 0 12px;
  border: 1px solid #e3ccd0;
  border-radius: 8px;
  color: #a44c5b;
  background: #fff;
  font-size: 11px;
  font-weight: 750;
}

.memo-actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.review-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 11px;
  line-height: 1.5;
}

.review-feedback.error {
  color: #8d3d48;
  background: #fff0f2;
}

.review-feedback.success {
  color: #267049;
  background: #eaf8f0;
}

.review-feedback button {
  margin-left: auto;
  border: 0;
  color: inherit;
  background: transparent;
  font-weight: 800;
  text-decoration: underline;
}

.review-screen-backdrop {
  z-index: 80;
}

.my-review-modal {
  width: min(100%, 940px);
  max-height: min(820px, 100vh - 40px);
  overflow: hidden;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 28px 70px rgba(3, 18, 39, 0.34);
}

.my-review-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px;
  color: #fff;
  background: linear-gradient(120deg, #0c2b55, #155698);
}

.my-review-header h2 {
  margin: 3px 0;
  font-size: 21px;
}

.my-review-header p:last-child {
  margin: 0;
  color: #c4d9ee;
  font-size: 12px;
}

.my-review-header > button {
  width: 34px;
  height: 34px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 8px;
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.my-review-body {
  max-height: calc(100vh - 170px);
  overflow: auto;
  padding: 20px 24px 24px;
}

.review-tabs {
  gap: 7px;
  border-bottom: 1px solid #e2e8f0;
}

.review-tabs button {
  min-height: 42px;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  border: 0;
  border-bottom: 2px solid transparent;
  color: #69788b;
  background: transparent;
  font-size: 12px;
  font-weight: 750;
}

.review-tabs button.active {
  border-bottom-color: #236bb1;
  color: #1b5d9c;
}

.review-tabs span {
  min-width: 20px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #edf2f7;
  font-size: 10px;
}

.my-review-controls {
  gap: 8px;
  margin: 14px 0;
}

.my-review-controls label:first-child {
  position: relative;
  flex: 1;
}

.my-review-controls label:first-child i {
  position: absolute;
  top: 13px;
  left: 12px;
  color: #7c899a;
}

.my-review-controls input,
.my-review-controls select {
  width: 100%;
  height: 42px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #d7e0ea;
  border-radius: 8px;
  outline: 0;
  color: #2c405a;
  background: #fff;
  font-size: 12px;
}

.my-review-controls input {
  padding-left: 34px;
}

.my-review-controls label:not(:first-child) {
  min-width: 150px;
}

.my-review-list {
  display: grid;
  gap: 10px;
}

.my-review-card {
  padding: 15px 16px;
  border: 1px solid #dce5ee;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
}

.my-review-card:hover,
.my-review-card:focus-visible {
  border-color: #91b9df;
  box-shadow: 0 5px 16px rgba(31, 91, 150, 0.1);
  outline: 0;
}

.my-review-card-main {
  justify-content: space-between;
  gap: 10px;
}

.my-review-card h3 {
  margin: 6px 0 0;
  color: #203853;
  font-size: 15px;
}

.my-review-status-control select {
  min-width: 112px;
  min-height: 32px;
  padding: 0 26px 0 9px;
  border-width: 1px;
  border-style: solid;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
}

.my-review-status-control select:disabled {
  opacity: 0.55;
  cursor: wait;
}

.my-review-card > p {
  margin: 12px 0;
  color: #50647c;
  font-size: 12px;
  line-height: 1.55;
}

.my-review-card footer {
  justify-content: space-between;
  gap: 12px;
  padding-top: 10px;
  border-top: 1px solid #edf1f5;
  color: #718096;
  font-size: 10px;
}

.my-review-card footer > div {
  display: flex;
  gap: 7px;
}

.review-compare {
  min-height: 30px;
  padding: 0 9px;
  border: 1px solid #d6e1ed;
  border-radius: 7px;
  color: #2b659e;
  background: #fff;
  font-size: 10px;
  font-weight: 750;
}

.review-compare i {
  margin-right: 5px;
}

.review-list-state {
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #697a8e;
  font-size: 12px;
}

.review-list-state.empty {
  flex-direction: column;
  text-align: center;
}

.review-list-state.empty > i {
  width: 48px;
  height: 48px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  color: #477cad;
  background: #edf5fc;
  font-size: 19px;
}

.review-list-state.empty strong {
  color: #2a415d;
  font-size: 14px;
}

.review-list-state.empty p {
  margin: 0;
}

.review-list-state.empty button {
  margin-top: 8px;
  padding: 9px 12px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  background: #2168ad;
  font-weight: 750;
}

.auth-backdrop {
  z-index: 100;
}

.auth-modal {
  width: min(100%, 430px);
  max-height: calc(100vh - 32px);
  overflow: auto;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 28px 70px rgba(3, 18, 39, 0.36);
}

.auth-header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: start;
  gap: 12px;
  padding: 21px 22px;
  color: #fff;
  background: linear-gradient(120deg, #0c2b55, #155698);
}

.auth-header .brand-mark {
  background: rgba(255, 255, 255, 0.14);
}

.auth-header h2 {
  margin: 1px 0 5px;
  font-size: 19px;
}

.auth-header p {
  margin: 0;
  color: #c6daee;
  font-size: 11px;
  line-height: 1.45;
}

.auth-header > button {
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 8px;
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.auth-body {
  padding: 22px;
}

.auth-body form {
  display: grid;
  gap: 15px;
}

.auth-body form label {
  display: grid;
  gap: 7px;
  color: #334a65;
  font-size: 12px;
  font-weight: 750;
}

.auth-body form label small {
  color: #718095;
  font-size: 10px;
  font-weight: 500;
}

.auth-body input {
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  padding: 0 12px;
  border: 1px solid #d3dde8;
  border-radius: 8px;
  outline: 0;
  color: #263c57;
  background: #fff;
  font-size: 13px;
}

.auth-body input:focus {
  border-color: #3178bf;
  box-shadow: 0 0 0 3px rgba(49, 120, 191, 0.14);
}

.auth-primary {
  min-height: 44px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  background: #1e65ab;
  font-size: 13px;
  font-weight: 800;
}

.auth-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.auth-links {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.auth-links button {
  border: 0;
  color: #356da7;
  background: transparent;
  font-size: 11px;
}

.auth-feedback,
.auth-config-note {
  margin: 0 0 15px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 11px;
  line-height: 1.5;
}

.auth-feedback.error {
  color: #8f3e48;
  background: #fff0f2;
}

.auth-feedback.success {
  color: #267049;
  background: #eaf8f0;
}

.auth-config-note {
  color: #805d20;
  background: #fff7e5;
}

button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible,
[tabindex="0"]:focus-visible {
  outline: 3px solid rgba(44, 123, 199, 0.35);
  outline-offset: 2px;
}

@media (max-width: 1100px) {
  .comparison-header {
    align-items: stretch;
    flex-direction: column;
  }
  .comparison-actions {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}
@media (max-width: 760px) {
  .topbar-actions {
    gap: 6px;
  }
  .my-review-button {
    padding: 0 9px;
  }
  .my-review-button {
    font-size: 0;
  }
  .my-review-button i,
  .my-review-button span {
    font-size: 11px;
  }
  .account-button {
    max-width: 120px;
  }
  .account-button span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .comparison-options {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .comparison-options label {
    justify-content: center;
  }
  .personal-login-prompt {
    grid-template-columns: auto 1fr;
  }
  .personal-login-prompt button {
    grid-column: 1/-1;
    width: 100%;
  }
  .personal-review-toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .review-status-field {
    justify-content: space-between;
  }
  .review-status-field select {
    flex: 1;
  }
  .memo-actions > span {
    width: 100%;
  }
  .my-review-modal {
    max-height: calc(100vh - 24px);
  }
  .my-review-header,
  .my-review-body {
    padding-left: 17px;
    padding-right: 17px;
  }
  .my-review-controls {
    align-items: stretch;
    flex-direction: column;
  }
  .my-review-controls label:not(:first-child) {
    width: 100%;
    min-width: 0;
  }
  .my-review-card footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .my-review-card footer > div {
    width: 100%;
    justify-content: flex-end;
  }
  .auth-modal {
    max-height: calc(100vh - 20px);
  }
}
@media (max-width: 430px) {
  .login-button {
    width: 38px;
    padding: 0;
    font-size: 0;
  }
  .login-button i {
    font-size: 12px;
  }
  .account-button {
    width: 38px;
    padding: 0;
  }
  .account-button span {
    display: none;
  }
  .comparison-options {
    grid-template-columns: 1fr;
  }
  .review-tabs button {
    flex: 1;
    justify-content: center;
    padding: 0 7px;
  }
}
/* BioScope v0.3 research data extension */
.summary-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.summary-icon.navy {
  color: #174e88;
  background: #e8f1fb;
}

.filter-panel {
  max-height: calc(100vh - 96px);
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: #c8d8e8 transparent;
}

.filter-heading {
  position: sticky;
  z-index: 2;
  top: 0;
  background: #fff;
}

.filter-heading button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.filter-tip {
  position: sticky;
  bottom: 0;
  border: 1px solid #e4ebf3;
}

.download-group {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.download-button {
  min-width: 74px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #d4dfeb;
  border-radius: 8px;
  color: #285f96;
  background: #fff;
  font-size: 12px;
  font-weight: 750;
  white-space: nowrap;
  transition: border-color 0.16s, background 0.16s, color 0.16s;
}

.download-button:hover:not(:disabled) {
  border-color: #91b7dc;
  background: #f1f7fe;
}

.download-button.csv i {
  color: #3971a7;
}

.download-button.xlsx i {
  color: #21815d;
}

.download-button:disabled {
  color: #a1abb8;
  background: #f4f6f8;
  cursor: not-allowed;
}

.download-button:disabled i {
  color: #a1abb8;
}

.company-table {
  min-width: 1110px;
}

.company-table th:nth-child(2) {
  width: 185px;
}

.company-table th:nth-child(3) {
  width: 210px;
}

.company-table th:nth-child(4) {
  width: 215px;
}

.company-table th:nth-child(5) {
  width: 175px;
}

.company-table th:nth-child(6) {
  width: 125px;
}

.technology-cell,
.classification-preview,
.cell-note,
.multiline-cell {
  overflow-wrap: anywhere;
  word-break: keep-all;
}

.listing-badge {
  display: inline-flex;
  align-items: center;
  min-height: 25px;
  padding: 3px 8px;
  border: 1px solid #d6dee8;
  border-radius: 999px;
  color: #66758a;
  background: #f5f7fa;
  font-size: 11px;
  font-weight: 800;
}

.listing-badge.is-listed {
  border-color: #b8d5f2;
  color: #195d9e;
  background: #edf6ff;
}

.classification-preview,
.linked-count + small {
  display: block;
  margin-top: 7px;
  color: #6d7d91;
  font-size: 11px;
  line-height: 1.45;
}

.linked-count {
  display: block;
  color: #173f6d;
  font-size: 15px;
}

.record-count {
  color: #315f91;
  font-size: 12px;
  font-weight: 750;
}

.comparison-header {
  gap: 20px;
}

.comparison-header > div:first-child {
  min-width: 0;
}

.comparison-actions {
  flex-wrap: wrap;
  justify-content: flex-end;
}

.comparison-table td {
  min-width: 280px;
}

.comparison-table th:first-child {
  width: 220px;
}

.multiline-cell {
  white-space: pre-line;
}

.cell-note {
  display: block;
  margin-top: 7px;
  color: #68788c;
  font-size: 11px;
  line-height: 1.5;
  white-space: pre-line;
}

.comparison-more {
  display: flex;
  justify-content: center;
  padding: 13px 18px 16px;
  border-top: 1px solid #e5ebf2;
  background: #fbfcfe;
}

.comparison-more button {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  border: 1px solid #cbdbea;
  border-radius: 8px;
  color: #225e99;
  background: #fff;
  font-size: 12px;
  font-weight: 750;
}

.modal-backdrop {
  padding: 16px;
}

.detail-modal {
  width: min(1180px, 100%);
  max-height: calc(100vh - 32px);
  border: 1px solid rgba(190, 205, 222, 0.6);
}

.detail-header {
  position: sticky;
  z-index: 5;
  top: 0;
  min-height: 118px;
  padding: 24px 32px;
  box-shadow: 0 6px 18px rgba(6, 31, 65, 0.15);
}

.detail-header > div:first-child {
  min-width: 0;
}

.detail-kickers {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.detail-id {
  padding: 4px 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  color: #c7dcf3;
  background: rgba(255, 255, 255, 0.06);
  font-size: 11px;
  font-weight: 700;
}

.detail-body {
  padding: 0 32px 30px;
}

.detail-section {
  padding: 30px 0 34px;
  border-bottom: 1px solid #dfe7f0;
  scroll-margin-top: 130px;
}

.detail-section:last-child {
  border-bottom: 0;
}

.section-heading {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr);
  align-items: start;
  gap: 12px;
  margin-bottom: 20px;
}

.section-heading-with-count {
  grid-template-columns: 42px minmax(0, 1fr) auto;
}

.section-index {
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  border: 1px solid #c9def3;
  border-radius: 11px;
  color: #1d65aa;
  background: #edf6ff;
  font-size: 12px;
  font-weight: 900;
}

.section-heading h3 {
  margin: 0;
  color: #152c49;
  font-size: 20px;
  letter-spacing: -0.3px;
}

.section-heading p {
  margin: 6px 0 0;
  color: #63758b;
  font-size: 13px;
  line-height: 1.55;
}

.section-count {
  align-self: center;
  padding: 7px 11px;
  border-radius: 999px;
  color: #285f96;
  background: #edf5fd;
  font-size: 12px;
  white-space: nowrap;
}

.overview-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.overview-card {
  min-width: 0;
  padding: 20px;
  border: 1px solid #dce5ef;
  border-radius: 13px;
  background: #fff;
}

.official-card {
  box-shadow: inset 0 3px 0 #276fba;
}

.screening-card {
  box-shadow: inset 0 3px 0 #7087a5;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 17px;
  color: #245d98;
}

.card-title h4 {
  margin: 0;
  color: #20364f;
  font-size: 15px;
}

.fact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px 18px;
  margin: 0;
}

.fact-grid > div {
  min-width: 0;
}

.fact-grid > .wide-fact {
  grid-column: 1/-1;
}

.fact-grid dt,
.record-details dt,
.source-meta dt {
  margin-bottom: 5px;
  color: #65758a;
  font-size: 11px;
  font-weight: 750;
}

.fact-grid dd,
.record-details dd,
.source-meta dd {
  margin: 0;
  color: #253950;
  font-size: 13px;
  line-height: 1.55;
  overflow-wrap: anywhere;
  white-space: pre-line;
}

.inline-link {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 18px;
  color: #1e65a9;
  font-size: 12px;
  font-weight: 750;
  text-decoration: none;
}

.inline-link:hover {
  text-decoration: underline;
}

.classification-warning {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 18px;
  padding: 12px 13px;
  border: 1px solid #ecd69f;
  border-radius: 9px;
  color: #795817;
  background: #fff9e9;
}

.classification-warning i {
  margin-top: 2px;
}

.classification-warning p {
  margin: 0;
  font-size: 12px;
  line-height: 1.55;
}

.technology-summary-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}

.technology-summary-grid article {
  min-width: 0;
  padding: 17px 18px;
  border: 1px solid #dce6f0;
  border-radius: 11px;
  background: #f8fbfe;
}

.technology-summary-grid span,
.record-grid span {
  display: block;
  margin-bottom: 7px;
  color: #61758d;
  font-size: 11px;
  font-weight: 750;
}

.technology-summary-grid p {
  margin: 0;
  color: #263b54;
  font-size: 13px;
  line-height: 1.65;
  white-space: pre-line;
}

.research-disclosure,
.record-details {
  margin-top: 9px;
  border: 1px solid #dce5ee;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.research-disclosure summary,
.record-details summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 46px;
  padding: 11px 15px;
  color: #27435f;
  background: #f7f9fc;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  list-style: none;
}

.research-disclosure summary::-webkit-details-marker,
.record-details summary::-webkit-details-marker {
  display: none;
}

.research-disclosure summary i {
  transition: transform 0.18s;
}

.research-disclosure[open] summary i {
  transform: rotate(180deg);
}

.research-disclosure > p,
.research-disclosure > small {
  display: block;
  margin: 0;
  padding: 15px;
  color: #32465e;
  font-size: 13px;
  line-height: 1.7;
  white-space: pre-line;
}

.research-disclosure > small {
  padding-top: 0;
  color: #8a681d;
  font-size: 11px;
}

.research-disclosure.claim-boundary {
  border-color: #cfdff0;
  background: #f6faff;
}

.product-list,
.funding-list,
.source-record-list {
  display: grid;
  gap: 14px;
}

.product-record,
.funding-record,
.source-record,
.change-record {
  min-width: 0;
  border: 1px solid #dce5ef;
  border-radius: 13px;
  background: #fff;
  overflow: hidden;
}

.record-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 17px 18px;
  border-bottom: 1px solid #e2e9f0;
  background: #f7faff;
}

.record-header > div:first-child {
  min-width: 0;
}

.record-header h4 {
  margin: 5px 0 0;
  color: #1b3553;
  font-size: 16px;
  line-height: 1.4;
}

.record-id {
  display: block;
  color: #66809a;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.25px;
}

.record-purpose {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 14px 18px;
  border-bottom: 1px solid #edf1f5;
}

.record-purpose p {
  margin: 0;
  color: #40536a;
  font-size: 12px;
  line-height: 1.6;
}

.record-purpose strong {
  display: block;
  margin-bottom: 4px;
  color: #65768a;
  font-size: 10px;
}

.record-grid {
  display: grid;
  gap: 0;
  padding: 0 18px;
}

.product-grid,
.funding-grid {
  grid-template-columns: repeat(3, 1fr);
}

.record-grid > div {
  min-width: 0;
  padding: 14px 14px 14px 0;
  border-bottom: 1px solid #edf1f5;
}

.record-grid > div:not(:nth-child(3n+1)) {
  padding-left: 14px;
  border-left: 1px solid #edf1f5;
}

.record-grid .wide-record {
  grid-column: span 3;
  padding-left: 0;
  border-left: 0;
}

.record-grid strong {
  display: block;
  color: #263a52;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.6;
  overflow-wrap: anywhere;
  white-space: pre-line;
}

.record-grid strong + small {
  display: block;
  margin-top: 5px;
  color: #7a8797;
  font-size: 10px;
  overflow-wrap: anywhere;
}

.record-details {
  margin: 14px 18px;
}

.record-details dl {
  display: grid;
  gap: 13px;
  margin: 0;
  padding: 16px;
}

.record-details dl > div {
  display: grid;
  grid-template-columns: 155px minmax(0, 1fr);
  gap: 14px;
}

.record-footer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(260px, 0.8fr);
  gap: 16px;
  padding: 14px 18px;
  background: #fbfcfe;
}

.record-footer.source-only {
  grid-template-columns: 1fr;
}

.record-follow-up {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 11px;
  border-radius: 8px;
  color: #805d1b;
  background: #fff8e8;
}

.record-follow-up i {
  margin-top: 3px;
}

.record-follow-up p {
  margin: 0;
  font-size: 11px;
  line-height: 1.6;
  white-space: pre-line;
}

.record-sources {
  display: grid;
  align-content: start;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.record-sources a {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid #d8e5f2;
  border-radius: 7px;
  color: #1f619f;
  background: #f5f9fd;
  font-size: 11px;
  line-height: 1.45;
  text-decoration: none;
}

.record-sources a span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.record-sources a:hover {
  border-color: #9fc1e2;
  background: #edf6ff;
}

.record-badges {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 6px;
}

.funding-type-badge,
.availability-badge,
.source-kind {
  padding: 5px 8px;
  border: 1px solid #cbdff2;
  border-radius: 999px;
  color: #275f95;
  background: #edf6ff;
  font-size: 10px;
  font-weight: 800;
}

.availability-badge {
  border-color: #cbe5d7;
  color: #276f4e;
  background: #eefaf4;
}

.availability-badge.is-unavailable {
  border-color: #ead69f;
  color: #815e18;
  background: #fff9e8;
}

.source-record {
  padding: 17px 18px;
}

.source-record-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.source-record-heading > div {
  min-width: 0;
}

.source-record-heading a {
  display: inline-flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 5px;
  color: #175e9e;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.5;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.source-record-heading a:hover {
  text-decoration: underline;
}

.source-meta {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin: 16px 0 0;
  padding: 13px;
  border-radius: 9px;
  background: #f7f9fc;
}

.source-summary {
  margin: 14px 0 0;
  color: #354a62;
  font-size: 12px;
  line-height: 1.65;
  white-space: pre-line;
}

.access-note {
  display: block;
  margin-top: 10px;
  color: #6e7e90;
  font-size: 10px;
  line-height: 1.5;
}

.changes-block {
  margin-top: 26px;
  padding-top: 24px;
  border-top: 1px solid #dfe7ef;
}

.changes-block > h4 {
  margin: 0;
  color: #20364f;
  font-size: 16px;
}

.block-description {
  margin: 6px 0 15px;
  color: #6a7a8e;
  font-size: 12px;
}

.change-record {
  margin-top: 10px;
  padding: 15px 16px;
}

.change-record header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.change-record header span,
.change-record header small {
  padding: 3px 7px;
  border-radius: 999px;
  color: #315e8d;
  background: #edf5fd;
  font-size: 10px;
  font-weight: 750;
}

.change-record header strong {
  color: #243a53;
  font-size: 13px;
}

.change-record header small {
  margin-left: auto;
  color: #4e6c59;
  background: #eef8f2;
}

.change-values {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.change-values > div {
  min-width: 0;
  padding: 11px 12px;
  border-radius: 8px;
  background: #f7f9fc;
}

.change-values span {
  color: #738195;
  font-size: 10px;
  font-weight: 750;
}

.change-values p {
  margin: 5px 0 0;
  color: #334961;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-line;
}

.change-values > i {
  color: #7e99b4;
}

.change-reason,
.change-follow-up {
  margin: 10px 0 0;
  color: #55687e;
  font-size: 11px;
  line-height: 1.6;
  white-space: pre-line;
}

.change-reason strong,
.change-follow-up strong {
  margin-right: 7px;
  color: #304b69;
}

.inline-empty {
  padding: 18px;
  border: 1px dashed #ccd8e4;
  border-radius: 9px;
  color: #78879a;
  background: #fafbfd;
  font-size: 12px;
  text-align: center;
}

.verification-note {
  margin-top: 18px;
}

.detail-source-date {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  color: #6d7c8f;
  font-size: 11px;
}

.detail-source-date strong {
  color: #294a6c;
}

.detail-footer {
  position: sticky;
  z-index: 5;
  bottom: 0;
  align-items: center;
  box-shadow: 0 -5px 16px rgba(20, 43, 70, 0.08);
}

.detail-footer a.secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  text-decoration: none;
}

@media (max-width: 1180px) {
  .summary-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .workspace {
    grid-template-columns: 1fr;
  }
  .filter-panel {
    position: static;
    max-height: none;
    overflow: visible;
  }
  .filter-heading,
  .filter-tip {
    position: static;
  }
  .filter-groups {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0 12px;
  }
  .filter-tip {
    margin-top: 0;
  }
}
@media (max-width: 900px) {
  .summary-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .list-actions {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .sort-controls {
    flex: 1 1 100%;
  }
  .download-group {
    flex: 1 1 auto;
  }
  .list-actions .download-group .download-button {
    flex: 1;
  }
  .overview-grid,
  .technology-summary-grid {
    grid-template-columns: 1fr;
  }
  .product-grid,
  .funding-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .record-grid > div,
  .record-grid > div:not(:nth-child(3n+1)) {
    padding-left: 0;
    padding-right: 14px;
    border-left: 0;
  }
  .record-grid > div:nth-child(even) {
    padding-left: 14px;
    border-left: 1px solid #edf1f5;
  }
  .record-grid .wide-record {
    grid-column: span 2;
    padding-left: 0;
    border-left: 0;
  }
  .record-footer {
    grid-template-columns: 1fr;
  }
  .source-meta {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 760px) {
  .shell {
    width: min(100% - 24px, 1360px);
  }
  .summary-grid {
    gap: 9px;
  }
  .summary-card {
    min-height: 92px;
  }
  .filter-groups {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .filter-group {
    margin-top: 12px;
  }
  .list-actions {
    flex-direction: column;
  }
  .download-group {
    width: 100%;
  }
  .download-button {
    flex: 1;
  }
  .comparison-actions {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
  }
  .comparison-actions .download-group {
    width: 100%;
  }
  .comparison-actions .clear-all {
    width: 100%;
    min-height: 40px;
  }
  .comparison-table td {
    min-width: 245px;
  }
  .comparison-table th:first-child {
    width: 125px;
  }
  .modal-backdrop {
    padding: 0;
    place-items: stretch;
  }
  .detail-modal {
    width: 100%;
    max-height: 100vh;
    border: 0;
    border-radius: 0;
  }
  .detail-header {
    min-height: 104px;
    padding: 20px;
  }
  .detail-header h2 {
    font-size: 20px;
  }
  .detail-body {
    padding: 0 16px 22px;
  }
  .detail-section {
    padding: 24px 0 27px;
  }
  .section-heading,
  .section-heading-with-count {
    grid-template-columns: 38px minmax(0, 1fr);
    gap: 10px;
  }
  .section-index {
    width: 38px;
    height: 38px;
  }
  .section-heading h3 {
    font-size: 18px;
  }
  .section-heading p {
    font-size: 12px;
  }
  .section-count {
    grid-column: 2;
    justify-self: start;
    align-self: start;
  }
  .overview-card {
    padding: 16px;
  }
  .fact-grid {
    grid-template-columns: 1fr;
  }
  .fact-grid > .wide-fact {
    grid-column: auto;
  }
  .record-header {
    flex-direction: column;
  }
  .record-badges {
    justify-content: flex-start;
  }
  .record-purpose,
  .product-grid,
  .funding-grid {
    grid-template-columns: 1fr;
  }
  .record-grid > div,
  .record-grid > div:nth-child(even),
  .record-grid > div:not(:nth-child(3n+1)) {
    padding: 13px 0;
    border-left: 0;
  }
  .record-grid .wide-record {
    grid-column: auto;
  }
  .record-details dl > div {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  .source-record-heading {
    flex-direction: column;
  }
  .source-meta {
    grid-template-columns: 1fr;
  }
  .change-values {
    grid-template-columns: 1fr;
  }
  .change-values > i {
    transform: rotate(90deg);
    justify-self: center;
  }
  .detail-footer {
    flex-wrap: wrap;
    padding: 11px 14px;
  }
  .detail-footer .secondary,
  .detail-footer .primary {
    min-width: 0;
    flex: 1 1 calc(50% - 6px);
  }
  .detail-footer a.secondary {
    order: 3;
    flex-basis: 100%;
  }
}
@media (max-width: 430px) {
  .shell {
    width: calc(100% - 20px);
  }
  .hero h1 {
    font-size: 23px;
  }
  .summary-grid {
    grid-template-columns: 1fr 1fr;
  }
  .summary-card {
    min-width: 0;
    padding: 12px;
    gap: 10px;
  }
  .summary-icon {
    width: 36px;
    height: 36px;
  }
  .summary-card strong {
    font-size: 21px;
  }
  .summary-card span,
  .summary-card small {
    font-size: 11px;
  }
  .company-heading {
    flex-direction: column;
  }
  .selection-counter {
    align-self: flex-start;
  }
  .condition-meta {
    align-items: flex-start;
    flex-direction: column;
  }
  .condition-meta span {
    padding: 0;
    border: 0;
  }
  .record-header h4 {
    font-size: 15px;
  }
  .research-disclosure summary,
  .record-details summary {
    font-size: 12px;
  }
  .compare-dock {
    width: calc(100% - 14px);
  }
  .dock-actions button {
    padding: 0 10px;
  }
}`],
})
export class PageDashboardComponent implements OnInit {
    public companies: Company[] = [];
    public filteredCompanies: Company[] = [];
    public products: ProductRecord[] = [];
    public investments: InvestmentRecord[] = [];
    public classifications: ClassificationRecord[] = [];
    public sources: SourceRecord[] = [];
    public changes: ChangeRecord[] = [];
    public globalChanges: ChangeRecord[] = [];
    public idMap: IdMapRecord[] = [];
    public manifest: DataManifest | null = null;
    public searchTerm: string = '';
    public filters: Record<FilterKey, string> = this.emptyFilters();
    public sortKey: SortKey = 'companyName';
    public sortDirection: SortDirection = 'asc';
    public selectedIds: string[] = [];
    public detailCompany: Company | null = null;
    public loading: boolean = true;
    public loadError: string = '';
    public selectionNotice: string = '';
    public exportingTarget: ExportTarget | null = null;
    public showExtendedComparison: boolean = false;
    public highlightDifferences: boolean = false;
    public hideSameComparison: boolean = false;
    public authUser: AuthUser | null = null;
    public authReady: boolean = false;
    public csrfToken: string = '';
    public passwordResetAvailable: boolean = false;
    public showAuthDialog: boolean = false;
    public authView: AuthView = 'login';
    public authBusy: boolean = false;
    public authError: string = '';
    public authMessage: string = '';
    public authData = { identifier: '', username: '', email: '', password: '', newPassword: '' };
    public resetToken: string = '';
    public showAccountMenu: boolean = false;
    public reviewRecords: ReviewRecord[] = [];
    public reviewLoading: boolean = false;
    public reviewSaving: boolean = false;
    public reviewMessage: string = '';
    public reviewError: string = '';
    public reviewConflict: ReviewRecord | null = null;
    public detailMemoDraft: string = '';
    public detailMemoOriginal: string = '';
    public memoDirty: boolean = false;
    private memoRevision: number = 0;
    public showMyReviews: boolean = false;
    public myReviewTab: MyReviewTab = 'favorites';
    public myReviewSearch: string = '';
    public myReviewStatus: string = '';
    public myReviewSort: MyReviewSort = 'updated';
    public readonly reviewStatuses: ReviewStatus[] = ['검토 전', '검토 중', '추가 확인', '검토 완료'];
    public readonly maxSelection: number = 5;
    public readonly expectedCompanyCount: number = 30;
    public readonly expectedProductCount: number = 122;
    public readonly expectedInvestmentCount: number = 95;
    public readonly expectedSourceCount: number = 347;
    private pendingExpiredDraft: { userId: string; companyId: string; memo: string; original: string } | null = null;
    private readonly dataRoot: string = '/assets/data/research';
    private readonly developmentStageOrder: Record<string, number> = {
        '연구': 0,
        '비임상': 1,
        '임상 1상': 2,
        '임상 2상': 3,
        '임상 3상': 4,
        '허가 준비': 5,
        '상용화': 6
    };
    private readonly productStageOrder: string[] = [
        '연구개발', '비임상', '임상 준비·승인', '임상 1상', '임상 2상', '임상 3상',
        '허가·출시', '중단·일시중지', '해당 없음', '미확인', '기타·복합'
    ];
    private readonly regulatoryOrder: string[] = [
        '임상시험·IND', '품목허가·시판', '인증·품질', '지정', '일시중지',
        '해당 없음', '미확인', '기타·복합'
    ];
    private readonly businessStageOrder: string[] = [
        '연구개발', '비임상', '임상', '허가·출시 준비', '상용화·판매', '복합 단계', '미확인'
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit(): Promise<void> {
        await this.service.init();
        const resetToken = new URLSearchParams(window.location.search).get('reset_token');
        if (resetToken) {
            this.resetToken = resetToken;
            this.authView = 'reset';
            this.showAuthDialog = true;
        }
        await Promise.all([this.loadCompanies(), this.loadAuthStatus()]);
    }

    public async loadCompanies(): Promise<void> {
        this.loading = true;
        this.loadError = '';

        try {
            const [companies, products, investments, classifications, sources, changes, globalChanges, idMap, manifest] = await Promise.all([
                this.fetchJson<Company[]>('companies.json'),
                this.fetchJson<ProductRecord[]>('products.json'),
                this.fetchJson<InvestmentRecord[]>('funding.json'),
                this.fetchJson<ClassificationRecord[]>('classifications.json'),
                this.fetchJson<SourceRecord[]>('sources.json'),
                this.fetchJson<ChangeRecord[]>('changes.json'),
                this.fetchJson<ChangeRecord[]>('global-changes.json'),
                this.fetchJson<IdMapRecord[]>('company-id-map.json'),
                this.fetchJson<DataManifest>('manifest.json')
            ]);

            this.validateDataset(companies, products, investments, classifications, sources, changes, globalChanges, idMap);
            this.companies = companies;
            this.products = products;
            this.investments = investments;
            this.classifications = classifications;
            this.sources = sources;
            this.changes = changes;
            this.globalChanges = globalChanges;
            this.idMap = idMap;
            this.manifest = manifest;
            this.applyFilters();
        } catch (error) {
            console.error('v0.3 조사 데이터를 불러오지 못했습니다.', error);
            this.loadError = '기업 추가 조사 데이터를 불러오지 못했습니다. 데이터 변환·검증 결과를 확인해 주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public get industryOptions(): string[] {
        return this.uniqueCompanyValues('industry');
    }

    public get productTypeOptions(): string[] {
        return this.uniqueCompanyValues('productType');
    }

    public get regionOptions(): string[] {
        return this.uniqueCompanyValues('region');
    }

    public get stageOptions(): string[] {
        return this.uniqueCompanyValues('developmentStage').sort((first, second) => {
            const stageDifference = this.stageRank(first) - this.stageRank(second);
            return stageDifference || first.localeCompare(second, 'ko-KR');
        });
    }

    public get listingOptions(): string[] {
        return this.uniqueCompanyValues('listingStatus');
    }

    public get fundingTypeOptions(): string[] {
        return this.uniqueStrings(this.investments.map((investment) => investment.fundingType));
    }

    public get businessStageOptions(): string[] {
        const present = new Set(this.companies.map((company) => this.businessStageCategory(company)));
        return this.businessStageOrder.filter((category) => present.has(category));
    }

    public get productStageOptions(): string[] {
        const present = new Set(this.products.map((product) => this.productStageCategory(product)));
        return this.productStageOrder.filter((category) => present.has(category));
    }

    public get regulatoryOptions(): string[] {
        const present = new Set(this.products.map((product) => this.regulatoryCategory(product)));
        return this.regulatoryOrder.filter((category) => present.has(category));
    }

    public get selectedCompanies(): Company[] {
        return this.selectedIds
            .map((id) => this.companies.find((company) => company.id === id))
            .filter((company): company is Company => Boolean(company));
    }

    public get favoriteReviewCount(): number {
        return this.reviewRecords.filter((record) => record.favorite).length;
    }

    public get myReviewRows(): Array<{ company: Company; review: ReviewRecord }> {
        const keyword = this.normalizeSearch(this.myReviewSearch);
        const rows = this.reviewRecords
            .filter((review) => this.myReviewTab === 'all' || review.favorite)
            .filter((review) => !this.myReviewStatus || review.status === this.myReviewStatus)
            .map((review) => ({
                review,
                company: this.companies.find((company) => company.id === review.companyId)
            }))
            .filter((row): row is { company: Company; review: ReviewRecord } => Boolean(row.company))
            .filter((row) => !keyword || this.normalizeSearch(row.company.companyName).includes(keyword));
        return rows.sort((first, second) => {
            if (this.myReviewSort === 'company') {
                return first.company.companyName.localeCompare(second.company.companyName, 'ko-KR', { numeric: true });
            }
            return second.review.updatedAt.localeCompare(first.review.updatedAt);
        });
    }

    public get datasetCheckedAt(): string {
        const dates = this.uniqueStrings(this.companies.map((company) => company.researchCheckedAt));
        return dates.length === 1 ? dates[0] : dates.join(', ');
    }

    public get stageDistribution(): StageCount[] {
        return this.stageOptions.map((stage) => ({
            label: stage,
            count: this.companies.filter((company) => company.developmentStage === stage).length
        }));
    }

    public get activeFilterCount(): number {
        return this.activeConditions.length;
    }

    public get activeConditions(): ActiveCondition[] {
        const conditions: ActiveCondition[] = [];
        const labels: Record<FilterKey, string> = {
            industry: '주요 산업군',
            productType: '제품 유형',
            region: '소재 지역',
            developmentStage: '기존 요약 단계',
            listingStatus: '상장 여부',
            fundingType: '자금조달 유형',
            businessStage: '사업화 단계',
            productStage: '제품별 개발단계',
            regulatoryCategory: '제품별 인허가'
        };

        if (this.searchTerm.trim()) {
            conditions.push({ key: 'search', label: '검색어', value: this.searchTerm.trim() });
        }
        (Object.keys(this.filters) as FilterKey[]).forEach((key) => {
            if (this.filters[key]) conditions.push({ key, label: labels[key], value: this.filters[key] });
        });
        return conditions;
    }

    public applyFilters(): void {
        const keyword = this.normalizeSearch(this.searchTerm);
        const hasProductConditions = Boolean(this.filters.productStage || this.filters.regulatoryCategory);

        this.filteredCompanies = this.companies.filter((company) => {
            const companyProducts = this.productsFor(company);
            const companyKeywordMatch = !keyword || this.companySearchValues(company)
                .some((value) => this.normalizeSearch(value).includes(keyword));
            const productKeywordMatch = !keyword || companyProducts
                .some((product) => this.productSearchValues(product)
                    .some((value) => this.normalizeSearch(value).includes(keyword)));
            const productConditionsMatch = !hasProductConditions || companyProducts.some((product) => {
                const matchesConditions = (!this.filters.productStage || this.productStageCategory(product) === this.filters.productStage)
                    && (!this.filters.regulatoryCategory || this.regulatoryCategory(product) === this.filters.regulatoryCategory);
                const sameProductMatchesKeyword = !keyword
                    || companyKeywordMatch
                    || this.productSearchValues(product).some((value) => this.normalizeSearch(value).includes(keyword));
                return matchesConditions && sameProductMatchesKeyword;
            });

            return (companyKeywordMatch || productKeywordMatch)
                && productConditionsMatch
                && (!this.filters.industry || company.industry === this.filters.industry)
                && (!this.filters.productType || company.productType === this.filters.productType)
                && (!this.filters.region || company.region === this.filters.region)
                && (!this.filters.developmentStage || company.developmentStage === this.filters.developmentStage)
                && (!this.filters.listingStatus || company.listingStatus === this.filters.listingStatus)
                && (!this.filters.businessStage || this.businessStageCategory(company) === this.filters.businessStage)
                && (!this.filters.fundingType || this.investmentsFor(company)
                    .some((investment) => investment.fundingType === this.filters.fundingType));
        });
        this.sortCompanies();
    }

    public async updateSearch(value: string): Promise<void> {
        this.searchTerm = value;
        this.applyFilters();
        await this.service.render();
    }

    public async updateFilter(key: FilterKey, value: string): Promise<void> {
        this.filters = { ...this.filters, [key]: value };
        this.applyFilters();
        await this.service.render();
    }

    public async updateSortKey(key: SortKey): Promise<void> {
        this.sortKey = key;
        await this.applySort();
    }

    public async applySort(): Promise<void> {
        this.sortCompanies();
        await this.service.render();
    }

    public async updateSortDirection(direction: SortDirection): Promise<void> {
        this.sortDirection = direction;
        await this.applySort();
    }

    public async resetFilters(): Promise<void> {
        this.searchTerm = '';
        this.filters = this.emptyFilters();
        this.applyFilters();
        await this.service.render();
    }

    public async removeCondition(key: FilterKey | 'search'): Promise<void> {
        if (key === 'search') {
            this.searchTerm = '';
        } else {
            this.filters = { ...this.filters, [key]: '' };
        }
        this.applyFilters();
        await this.service.render();
    }

    public async toggleSelection(company: Company, event?: Event): Promise<void> {
        if (this.isSelected(company)) {
            await this.removeSelection(company.id);
            return;
        }

        if (this.selectedIds.length >= this.maxSelection) {
            const target = event?.target as HTMLInputElement | undefined;
            if (target) target.checked = false;
            this.selectionNotice = `현재 ${this.maxSelection}개 기업이 선택되어 있습니다. 기존 기업을 제외한 뒤 다시 선택해 주세요.`;
            await this.service.render();
            return;
        }

        this.selectedIds = [...this.selectedIds, company.id];
        this.selectionNotice = '';
        await this.service.render();
    }

    public async removeSelection(companyId: string): Promise<void> {
        this.selectedIds = this.selectedIds.filter((id) => id !== companyId);
        if (this.selectedIds.length < 2) {
            this.highlightDifferences = false;
            this.hideSameComparison = false;
        }
        this.selectionNotice = '';
        await this.service.render();
    }

    public async clearSelection(): Promise<void> {
        this.selectedIds = [];
        this.selectionNotice = '';
        this.showExtendedComparison = false;
        this.highlightDifferences = false;
        this.hideSameComparison = false;
        await this.service.render();
    }

    public async clearSelectionNotice(): Promise<void> {
        this.selectionNotice = '';
        await this.service.render();
    }

    public isSelected(company: Company): boolean {
        return this.selectedIds.includes(company.id);
    }

    public isComparisonDifferent(field: keyof Company): boolean {
        return this.comparisonValuesDifferent(this.selectedCompanies.map((company) => String(company[field] ?? '')));
    }

    public isComparisonTextDifferent(kind: 'technology' | 'products' | 'regulatory' | 'business' | 'classification' | 'funding' | 'sources'): boolean {
        const values = this.selectedCompanies.map((company) => {
            if (kind === 'technology') return company.technologyDifferentiation;
            if (kind === 'products') return this.productComparison(company);
            if (kind === 'regulatory') return this.regulatoryComparison(company);
            if (kind === 'business') return company.commercializationStage;
            if (kind === 'classification') {
                const officialTypes = company.companyType
                    .split(/[,;\n]+/)
                    .map((value) => value.trim())
                    .filter(Boolean)
                    .sort((first, second) => first.localeCompare(second, 'ko-KR'))
                    .join(',');
                return `${company.listingStatus}|${company.listingMarket}|${officialTypes}|${company.screeningClassification}`;
            }
            if (kind === 'funding') return this.fundingComparison(company);
            return this.sourceBasisComparison(company);
        });
        return this.comparisonValuesDifferent(values, ['products', 'regulatory', 'funding', 'sources'].includes(kind));
    }

    public comparisonRowVisible(different: boolean): boolean {
        return !this.hideSameComparison || this.selectedCompanies.length < 2 || different;
    }

    public async toggleDifferenceHighlight(event: Event): Promise<void> {
        if (this.selectedCompanies.length < 2) return;
        this.highlightDifferences = (event.target as HTMLInputElement).checked;
        await this.service.render();
    }

    public async toggleHideSameComparison(event: Event): Promise<void> {
        if (this.selectedCompanies.length < 2) return;
        this.hideSameComparison = (event.target as HTMLInputElement).checked;
        await this.service.render();
    }

    public reviewFor(company: Company | string): ReviewRecord | null {
        const companyId = typeof company === 'string' ? company : company.id;
        return this.reviewRecords.find((record) => record.companyId === companyId) || null;
    }

    public isFavorite(company: Company): boolean {
        return Boolean(this.reviewFor(company)?.favorite);
    }

    public reviewStatus(company: Company): ReviewStatus {
        return this.reviewFor(company)?.status || '검토 전';
    }

    public reviewStatusClass(status: ReviewStatus | string): string {
        const classes: Record<string, string> = {
            '검토 전': 'review-before',
            '검토 중': 'review-progress',
            '추가 확인': 'review-check',
            '검토 완료': 'review-complete'
        };
        return classes[status] || 'review-before';
    }

    public reviewDate(value: string): string {
        if (!value) return '—';
        const parsed = new Date(value);
        return Number.isNaN(parsed.getTime()) ? value : parsed.toLocaleString('ko-KR', { dateStyle: 'medium', timeStyle: 'short' });
    }

    public memoSummary(memo: string): string {
        const normalized = String(memo || '').replace(/\s+/g, ' ').trim();
        if (!normalized) return '메모 없음';
        return normalized.length > 80 ? `${normalized.slice(0, 80)}…` : normalized;
    }

    public get isMemoDirty(): boolean {
        return this.memoDirty;
    }

    public async updateMemoDraft(event: Event): Promise<void> {
        const target = event.target as HTMLTextAreaElement | null;
        this.detailMemoDraft = target?.value || '';
        this.memoDirty = this.detailMemoDraft !== this.detailMemoOriginal;
        this.memoRevision += 1;
        await this.service.render();
    }

    public sourceLinks(company: Company): SourceLink[] {
        return this.sourcesFor(company)
            .filter((source) => this.isHttpUrl(source.url))
            .map((source) => ({ label: source.title, url: source.url }));
    }

    public classificationFor(company: Company): ClassificationRecord | null {
        return this.classifications.find((record) => record.companyId === company.id) || null;
    }

    public productsFor(company: Company): ProductRecord[] {
        return this.products.filter((product) => product.companyId === company.id);
    }

    public investmentsFor(company: Company): InvestmentRecord[] {
        return this.investments.filter((investment) => investment.companyId === company.id);
    }

    public sourcesFor(company: Company): SourceRecord[] {
        return this.sources.filter((source) => source.companyId === company.id);
    }

    public changesFor(company: Company): ChangeRecord[] {
        return this.changes.filter((change) => change.companyId === company.id);
    }

    public sourceRecordsForIds(sourceIds: string[]): SourceRecord[] {
        const wanted = new Set(sourceIds || []);
        return this.sources.filter((source) => wanted.has(source.sourceId));
    }

    public display(value: unknown): string {
        if (value === null || value === undefined || String(value).trim() === '') return '—';
        return String(value);
    }

    public displayEvidence(value: string): string {
        if (!value) return '—';
        const idPattern = /^(?:A-[A-Z0-9]+-\d+|C\d+-S\d+|V02-\d+|CBH-\d+(?:-[PI]\d+)?)$/i;
        const pieces = value
            .split(';')
            .map((piece) => piece.trim())
            .filter((piece) => piece && !/^source_ids?:/i.test(piece) && !idPattern.test(piece))
            .map((piece) => piece.replace(/^fact:\s*/i, '').trim())
            .filter(Boolean);
        return pieces.length ? pieces.join(' · ') : value.replace(/\bfact:\s*/gi, '').replace(/\bsource_ids?:\s*/gi, '');
    }

    public formatAmount(investment: InvestmentRecord): string {
        return this.formatMonetaryValue(
            investment.roundAmountValue,
            investment.currency,
            investment.amountUnit,
            investment.roundAmountRaw
        );
    }

    public formatCumulativeAmount(investment: InvestmentRecord): string {
        return this.formatMonetaryValue(
            investment.cumulativeAmountValue,
            investment.cumulativeCurrency,
            investment.cumulativeUnit,
            investment.cumulativeAmountRaw
        );
    }

    public formatValuation(investment: InvestmentRecord): string {
        return this.formatMonetaryValue(
            investment.valuationValue,
            investment.valuationCurrency,
            investment.valuationUnit,
            investment.valuationRaw
        );
    }

    public productStageCategory(product: ProductRecord): string {
        const text = this.normalizeSearch(`${product.developmentStageRaw} ${product.regulatoryStatus}`);
        if (!text || /공개자료 확인 불가|미확인/.test(text)) return '미확인';
        if (/해당 없음/.test(text)) return '해당 없음';
        if (/일시중지|suspended|terminated|중단/.test(text)) return '중단·일시중지';
        if (/품목허가|허가 후|승인.*판매|상용|판매|출시|시판|공급|수출 사업화|제품 등록/.test(text)) return '허가·출시';
        if (/3상|phase\s*3|2b\/3|2\/3상/.test(text)) return '임상 3상';
        if (/2상|phase\s*2|1\/2상|1\/2/.test(text)) return '임상 2상';
        if (/1상|1a|1b|phase\s*1|최초인체/.test(text)) return '임상 1상';
        if (/ind|임상 승인|임상 준비|임상시험계획/.test(text)) return '임상 준비·승인';
        if (/비임상|전임상|ind-enabling/.test(text)) return '비임상';
        if (/연구|후보발굴|개발/.test(text)) return '연구개발';
        return '기타·복합';
    }

    public regulatoryCategory(product: ProductRecord): string {
        const text = this.normalizeSearch([
            product.regulatoryType,
            product.regulatoryStatus,
            product.regulatoryName
        ].join(' '));
        if (!text || /공개자료 확인 불가|미확인/.test(text)) return '미확인';
        if (/해당 없음/.test(text)) return '해당 없음';
        if (/일시중지|suspended/.test(text)) return '일시중지';
        if (/품목허가|시판|510\(k\)|fda 허가|nmpa 승인|의료기기 허가|수출허가|허가 취득|허가 제품/.test(text)) return '품목허가·시판';
        if (/임상시험|ind|recruiting|completed|not yet recruiting|phase/.test(text)) return '임상시험·IND';
        if (/인증|ce-|ce |iso|gmp|신고|등록/.test(text)) return '인증·품질';
        if (/지정/.test(text)) return '지정';
        return '기타·복합';
    }

    public businessStageCategory(company: Company): string {
        const text = this.normalizeSearch(company.commercializationStage);
        if (!text || /공개자료 확인 불가/.test(text) && !/임상|비임상|판매|상용|허가/.test(text)) return '미확인';
        const hasCommercial = /판매|상용|매출|납품|수출|생산|공급|서비스/.test(text);
        const hasClinical = /임상/.test(text);
        const hasPreclinical = /비임상|전임상/.test(text);
        const hasApproval = /허가|인증|출시 준비|급여/.test(text);
        const categoryCount = [hasCommercial, hasClinical, hasPreclinical, hasApproval].filter(Boolean).length;
        if (categoryCount > 1 && hasCommercial && (hasClinical || hasPreclinical)) return '복합 단계';
        if (hasCommercial) return '상용화·판매';
        if (hasApproval) return '허가·출시 준비';
        if (hasClinical) return '임상';
        if (hasPreclinical) return '비임상';
        if (/연구|개발|후보/.test(text)) return '연구개발';
        return '복합 단계';
    }

    public productComparison(company: Company): string {
        return this.productsFor(company)
            .map((product) => `${product.productName} — ${product.developmentStageRaw} (${product.stageAsOf})`)
            .join('\n');
    }

    public regulatoryComparison(company: Company): string {
        return this.productsFor(company)
            .map((product) => `${product.productName} — ${product.regulatoryStatus}`)
            .join('\n');
    }

    public fundingComparison(company: Company): string {
        return this.investmentsFor(company)
            .map((investment) => `${investment.actualInvestmentDate || investment.announcementDate} · ${investment.fundingType} · ${investment.round} · ${this.formatAmount(investment)} · ${investment.availabilityStatus}`)
            .join('\n');
    }

    public sourceBasisComparison(company: Company): string {
        const checkedDates = this.uniqueStrings(this.sourcesFor(company).map((source) => source.checkedAt));
        return `출처 ${this.sourcesFor(company).length}건 · 조사 확인일 ${checkedDates.join(', ') || '—'}`;
    }

    public async openDetail(company: Company): Promise<void> {
        if (this.detailCompany && this.detailCompany.id !== company.id && !this.confirmDiscardMemo()) return;
        this.detailCompany = company;
        this.syncDetailReview();
        await this.service.render();
    }

    public async closeDetail(): Promise<void> {
        if (!this.confirmDiscardMemo()) return;
        this.detailCompany = null;
        this.reviewError = '';
        this.reviewMessage = '';
        this.reviewConflict = null;
        await this.service.render();
    }

    public async loadAuthStatus(): Promise<void> {
        try {
            const response: any = await wiz.call('auth_status');
            if (response.code === 200) {
                this.authUser = response.data.authenticated ? response.data.user : null;
                this.csrfToken = response.data.csrfToken || '';
                this.passwordResetAvailable = Boolean(response.data.passwordResetAvailable);
                if (this.authUser) await this.loadPersonalReviews();
            }
        } catch (_error) {
            this.authUser = null;
        } finally {
            this.authReady = true;
            await this.service.render();
        }
    }

    public async loadPersonalReviews(): Promise<void> {
        if (!this.authUser || this.reviewLoading) return;
        this.reviewLoading = true;
        try {
            const response: any = await wiz.call('my_reviews');
            if (response.code === 200) {
                this.reviewRecords = Array.isArray(response.data.records) ? response.data.records : [];
                if (this.detailCompany && !this.isMemoDirty) this.syncDetailReview();
            } else if (response.code === 401) {
                this.handleSessionExpired(response.data?.message);
            }
        } finally {
            this.reviewLoading = false;
            await this.service.render();
        }
    }

    public async openAuth(view: AuthView = 'login', message: string = ''): Promise<void> {
        this.authView = view;
        this.authError = '';
        this.authMessage = message;
        this.showAuthDialog = true;
        this.showAccountMenu = false;
        await this.service.render();
    }

    public async closeAuth(): Promise<void> {
        if (this.authBusy) return;
        if (this.authView === 'reset' && this.resetToken) {
            this.resetToken = '';
            const url = new URL(window.location.href);
            url.searchParams.delete('reset_token');
            window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        }
        this.showAuthDialog = false;
        this.authError = '';
        this.authMessage = '';
        this.authData.password = '';
        this.authData.newPassword = '';
        await this.service.render();
    }

    public async setAuthView(view: AuthView): Promise<void> {
        this.authView = view;
        this.authError = '';
        this.authMessage = '';
        await this.service.render();
    }

    public async submitLogin(): Promise<void> {
        if (this.authBusy) return;
        this.authBusy = true;
        this.authError = '';
        await this.service.render();
        const response: any = await wiz.call('login', {
            identifier: this.authData.identifier,
            password: this.authData.password,
            csrfToken: this.csrfToken
        });
        if (response.code === 200) {
            this.authUser = response.data.user;
            this.csrfToken = response.data.csrfToken;
            this.showAuthDialog = false;
            this.authData.password = '';
            await this.loadPersonalReviews();
            this.restoreExpiredDraft();
        } else {
            this.authError = response.data?.message || '로그인에 실패했습니다.';
            if (response.code === 403) await this.refreshCsrf();
        }
        this.authBusy = false;
        await this.service.render();
    }

    public async submitRegistration(): Promise<void> {
        if (this.authBusy) return;
        this.authBusy = true;
        this.authError = '';
        await this.service.render();
        const response: any = await wiz.call('register', {
            username: this.authData.username,
            email: this.authData.email,
            password: this.authData.password,
            csrfToken: this.csrfToken
        });
        if (response.code === 201) {
            this.authUser = response.data.user;
            this.csrfToken = response.data.csrfToken;
            this.showAuthDialog = false;
            this.authData.password = '';
            this.pendingExpiredDraft = null;
            await this.loadPersonalReviews();
        } else {
            this.authError = response.data?.message || '회원가입을 완료하지 못했습니다.';
            if (response.code === 403) await this.refreshCsrf();
        }
        this.authBusy = false;
        await this.service.render();
    }

    public async requestPasswordReset(): Promise<void> {
        if (this.authBusy) return;
        this.authBusy = true;
        this.authError = '';
        this.authMessage = '';
        await this.service.render();
        const response: any = await wiz.call('request_password_reset', {
            email: this.authData.email,
            csrfToken: this.csrfToken
        });
        if (response.code === 200) {
            this.authMessage = response.data.message;
        } else {
            this.authError = response.data?.message || '재설정 요청을 처리하지 못했습니다.';
            if (response.code === 403) await this.refreshCsrf();
        }
        this.authBusy = false;
        await this.service.render();
    }

    public async submitPasswordReset(): Promise<void> {
        if (this.authBusy) return;
        this.authBusy = true;
        this.authError = '';
        await this.service.render();
        const response: any = await wiz.call('reset_password', {
            token: this.resetToken,
            password: this.authData.newPassword,
            csrfToken: this.csrfToken
        });
        if (response.code === 200) {
            this.csrfToken = response.data.csrfToken || this.csrfToken;
            this.authMessage = response.data.message;
            this.authView = 'login';
            this.resetToken = '';
            this.authData.newPassword = '';
            const url = new URL(window.location.href);
            url.searchParams.delete('reset_token');
            window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
        } else {
            this.authError = response.data?.message || '비밀번호를 변경하지 못했습니다.';
            if (response.code === 403) await this.refreshCsrf();
        }
        this.authBusy = false;
        await this.service.render();
    }

    public async logout(): Promise<void> {
        if (!this.confirmDiscardMemo()) return;
        const response: any = await wiz.call('logout', { csrfToken: this.csrfToken });
        if (response.code === 200) {
            this.csrfToken = response.data.csrfToken || '';
            this.clearPersonalState();
            this.pendingExpiredDraft = null;
        } else if (response.code === 403) {
            await this.refreshCsrf();
        }
        await this.service.render();
    }

    public async toggleAccountMenu(): Promise<void> {
        this.showAccountMenu = !this.showAccountMenu;
        await this.service.render();
    }

    public async toggleFavorite(company: Company, event?: Event): Promise<void> {
        event?.stopPropagation();
        if (!this.authUser) {
            await this.openAuth('login', '관심 기업을 저장하려면 로그인해 주세요.');
            return;
        }
        const current = this.reviewFor(company);
        await this.saveReviewPatch(company, { favorite: !Boolean(current?.favorite) });
    }

    public async changeReviewStatus(company: Company, status: ReviewStatus): Promise<void> {
        if (!this.authUser) {
            await this.openAuth('login', '검토 상태를 저장하려면 로그인해 주세요.');
            return;
        }
        await this.saveReviewPatch(company, { status });
    }

    public async changeReviewStatusFromEvent(company: Company, event: Event): Promise<void> {
        event.stopPropagation();
        const status = (event.target as HTMLSelectElement).value as ReviewStatus;
        await this.changeReviewStatus(company, status);
    }

    public async saveMemo(): Promise<void> {
        if (!this.detailCompany || !this.authUser || this.reviewSaving || this.reviewConflict) return;
        await this.saveReviewPatch(this.detailCompany, { memo: this.detailMemoDraft }, true);
    }

    public async deleteMemo(): Promise<void> {
        if (!this.detailCompany || !this.authUser || !this.detailMemoDraft) return;
        if (!window.confirm('이 개인 메모를 삭제하시겠습니까?')) return;
        this.detailMemoDraft = '';
        await this.saveReviewPatch(this.detailCompany, { memo: '' }, true);
    }

    public async reloadConflictedReview(): Promise<void> {
        await this.loadPersonalReviews();
        this.reviewConflict = null;
        this.syncDetailReview();
        this.reviewError = '';
        this.reviewMessage = '서버의 최신 기록을 다시 불러왔습니다.';
        await this.service.render();
    }

    public async openMyReviewScreen(): Promise<void> {
        if (!this.authUser) {
            await this.openAuth('login', '내 검토 기업을 보려면 로그인해 주세요.');
            return;
        }
        if (!this.confirmDiscardMemo()) return;
        this.detailCompany = null;
        this.showAccountMenu = false;
        this.showMyReviews = true;
        await this.service.render();
        await this.loadPersonalReviews();
    }

    public async closeMyReviewScreen(): Promise<void> {
        this.showMyReviews = false;
        await this.service.render();
    }

    public async openReviewedCompany(company: Company): Promise<void> {
        this.showMyReviews = false;
        await this.openDetail(company);
        setTimeout(() => document.getElementById('personal-review')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0);
    }

    public async setMyReviewTab(tab: MyReviewTab): Promise<void> {
        this.myReviewTab = tab;
        await this.service.render();
    }

    public async updateMyReviewSearch(value: string): Promise<void> {
        this.myReviewSearch = value;
        await this.service.render();
    }

    public async updateMyReviewStatus(value: string): Promise<void> {
        this.myReviewStatus = value;
        await this.service.render();
    }

    public async updateMyReviewSort(value: MyReviewSort): Promise<void> {
        this.myReviewSort = value;
        await this.service.render();
    }

    public async toggleExtendedComparison(): Promise<void> {
        this.showExtendedComparison = !this.showExtendedComparison;
        await this.service.render();
    }

    public scrollToCompare(): void {
        document.getElementById('comparison')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    public isExporting(scope: ExportScope, format: ExportFormat): boolean {
        return this.exportingTarget === `${scope}-${format}`;
    }

    public async downloadSearchResults(format: ExportFormat = 'xlsx'): Promise<void> {
        if (!this.filteredCompanies.length || this.exportingTarget) return;
        const target: ExportTarget = `search-${format}`;
        this.exportingTarget = target;
        await this.service.render();
        try {
            if (format === 'xlsx') {
                await this.downloadWorkbook(
                    `bioscope-search-results-${this.today()}.xlsx`,
                    this.buildSearchWorkbook(this.filteredCompanies)
                );
            } else {
                this.downloadCsv(
                    `bioscope-search-results-${this.today()}.csv`,
                    this.searchCsvRows(this.filteredCompanies)
                );
            }
        } catch (error) {
            console.error('검색 결과 파일을 생성하지 못했습니다.', error);
        } finally {
            this.exportingTarget = null;
            await this.service.render();
        }
    }

    public async downloadComparison(format: ExportFormat = 'xlsx'): Promise<void> {
        const companies = this.selectedCompanies;
        if (!companies.length || this.exportingTarget) return;
        const target: ExportTarget = `comparison-${format}`;
        this.exportingTarget = target;
        await this.service.render();
        try {
            if (format === 'xlsx') {
                await this.downloadWorkbook(
                    `bioscope-comparison-${this.today()}.xlsx`,
                    this.buildComparisonWorkbook(companies)
                );
            } else {
                this.downloadCsv(
                    `bioscope-comparison-${this.today()}.csv`,
                    this.comparisonCsvRows(companies)
                );
            }
        } catch (error) {
            console.error('비교 결과 파일을 생성하지 못했습니다.', error);
        } finally {
            this.exportingTarget = null;
            await this.service.render();
        }
    }

    public stageClass(stage: string): string {
        const classMap: Record<string, string> = {
            '연구': 'stage-research',
            '비임상': 'stage-preclinical',
            '임상 1상': 'stage-phase-one',
            '임상 2상': 'stage-phase-two',
            '임상 3상': 'stage-phase-three',
            '허가 준비': 'stage-review',
            '상용화': 'stage-commercial'
        };
        return classMap[stage] || 'stage-default';
    }

    @HostListener('document:keydown.escape')
    public async onEscape(): Promise<void> {
        if (this.showAuthDialog) {
            await this.closeAuth();
            return;
        }
        if (this.showMyReviews) {
            await this.closeMyReviewScreen();
            return;
        }
        if (this.detailCompany) {
            await this.closeDetail();
            return;
        }
        if (this.selectionNotice) await this.clearSelectionNotice();
    }

    @HostListener('window:beforeunload', ['$event'])
    public onBeforeUnload(event: BeforeUnloadEvent): void {
        if (!this.isMemoDirty) return;
        event.preventDefault();
        event.returnValue = '';
    }

    private async saveReviewPatch(
        company: Company,
        patch: { favorite?: boolean; status?: ReviewStatus; memo?: string },
        isMemoSave: boolean = false
    ): Promise<void> {
        if (!this.authUser || this.reviewSaving) return;
        const current = this.reviewFor(company);
        const memoRevisionAtStart = this.memoRevision;
        this.reviewSaving = true;
        this.reviewError = '';
        this.reviewMessage = '';
        await this.service.render();
        const payload: Record<string, unknown> = {
            companyId: company.id,
            version: current?.version || 0,
            csrfToken: this.csrfToken
        };
        if (patch.favorite !== undefined) payload.favorite = patch.favorite;
        if (patch.status !== undefined) payload.status = patch.status;
        if (patch.memo !== undefined) payload.memo = patch.memo;
        try {
            const response: any = await wiz.call('save_review', payload);
            if (response.code === 200) {
                this.applySavedReview(company.id, response.data.record || null);
                this.reviewConflict = null;
                if (isMemoSave) {
                    this.detailMemoOriginal = patch.memo ?? '';
                    this.memoDirty = this.memoRevision !== memoRevisionAtStart;
                    this.reviewMessage = patch.memo ? '개인 메모를 저장했습니다.' : '개인 메모를 삭제했습니다.';
                } else if (patch.favorite !== undefined) {
                    this.reviewMessage = patch.favorite ? '관심 기업에 저장했습니다.' : '관심 기업에서 해제했습니다. 기존 상태와 메모는 유지됩니다.';
                } else {
                    this.reviewMessage = '검토 상태를 저장했습니다.';
                }
            } else if (response.code === 401) {
                this.handleSessionExpired(response.data?.message);
            } else if (response.code === 409) {
                this.reviewConflict = response.data?.latest || {
                    companyId: company.id,
                    favorite: false,
                    status: '검토 전',
                    memo: '',
                    version: 0,
                    createdAt: '',
                    updatedAt: ''
                };
                this.reviewError = response.data?.message || '다른 화면에서 기록이 변경되었습니다. 최신 내용을 다시 불러와 주세요.';
            } else {
                this.reviewError = response.data?.message || '개인 기록을 저장하지 못했습니다. 입력 내용은 유지됩니다.';
                if (response.code === 403) await this.refreshCsrf();
            }
        } catch (_error) {
            this.reviewError = '서버와 연결하지 못해 저장하지 못했습니다. 입력 내용은 유지되며 다시 시도할 수 있습니다.';
        } finally {
            this.reviewSaving = false;
            await this.service.render();
        }
    }

    private applySavedReview(companyId: string, record: ReviewRecord | null): void {
        this.reviewRecords = this.reviewRecords.filter((item) => item.companyId !== companyId);
        if (record) this.reviewRecords = [record, ...this.reviewRecords];
    }

    private syncDetailReview(): void {
        if (!this.detailCompany) return;
        const record = this.reviewFor(this.detailCompany);
        this.detailMemoDraft = record?.memo || '';
        this.detailMemoOriginal = record?.memo || '';
        this.memoDirty = false;
        this.memoRevision = 0;
        this.reviewConflict = null;
        this.reviewError = '';
        this.reviewMessage = '';
    }

    private confirmDiscardMemo(): boolean {
        return !this.isMemoDirty || window.confirm('저장하지 않은 개인 메모 변경사항이 있습니다. 변경사항을 버리고 이동하시겠습니까?');
    }

    private clearPersonalState(): void {
        this.authUser = null;
        this.reviewRecords = [];
        this.detailMemoDraft = '';
        this.detailMemoOriginal = '';
        this.memoDirty = false;
        this.memoRevision = 0;
        this.reviewConflict = null;
        this.reviewError = '';
        this.reviewMessage = '';
        this.showAccountMenu = false;
        this.showMyReviews = false;
    }

    private handleSessionExpired(message?: string): void {
        const pending = this.authUser && this.detailCompany && this.isMemoDirty
            ? {
                userId: this.authUser.id,
                companyId: this.detailCompany.id,
                memo: this.detailMemoDraft,
                original: this.detailMemoOriginal
            }
            : null;
        this.clearPersonalState();
        this.pendingExpiredDraft = pending;
        this.authView = 'login';
        this.authError = message || '세션이 만료되었습니다. 다시 로그인해 주세요.';
        this.showAuthDialog = true;
    }

    private restoreExpiredDraft(): void {
        const pending = this.pendingExpiredDraft;
        this.pendingExpiredDraft = null;
        if (!pending || !this.authUser || pending.userId !== this.authUser.id || this.detailCompany?.id !== pending.companyId) return;
        this.detailMemoDraft = pending.memo;
        this.detailMemoOriginal = pending.original;
        this.memoDirty = this.detailMemoDraft !== this.detailMemoOriginal;
        this.memoRevision = this.memoDirty ? 1 : 0;
        this.reviewMessage = '세션 만료 전에 입력한 저장되지 않은 메모를 복원했습니다.';
    }

    private async refreshCsrf(): Promise<void> {
        const response: any = await wiz.call('auth_status');
        if (response.code === 200) this.csrfToken = response.data.csrfToken || '';
    }

    private comparisonValuesDifferent(values: string[], unordered: boolean = false): boolean {
        if (values.length < 2) return false;
        const normalized = values.map((value) => this.normalizeComparisonValue(value, unordered));
        if (normalized.every((value) => value === '__missing__')) return false;
        return new Set(normalized).size > 1;
    }

    private normalizeComparisonValue(value: unknown, unordered: boolean): string {
        const raw = String(value ?? '').replace(/\r\n/g, '\n').trim();
        if (!raw || /^(—|미확인|공개자료 확인 불가)$/i.test(raw)) return '__missing__';
        if (!unordered) return raw.replace(/\s+/g, ' ').toLocaleLowerCase('ko-KR');
        return raw
            .split(/\n+/)
            .map((line) => line.replace(/\s+/g, ' ').trim().toLocaleLowerCase('ko-KR'))
            .filter(Boolean)
            .sort((first, second) => first.localeCompare(second, 'ko-KR', { numeric: true }))
            .join('\n');
    }

    private emptyFilters(): Record<FilterKey, string> {
        return {
            industry: '',
            productType: '',
            region: '',
            developmentStage: '',
            listingStatus: '',
            fundingType: '',
            businessStage: '',
            productStage: '',
            regulatoryCategory: ''
        };
    }

    private async fetchJson<T>(filename: string): Promise<T> {
        const response = await fetch(`${this.dataRoot}/${filename}`);
        if (!response.ok) throw new Error(`${filename}: HTTP ${response.status}`);
        return response.json() as Promise<T>;
    }

    private validateDataset(
        companies: Company[],
        products: ProductRecord[],
        investments: InvestmentRecord[],
        classifications: ClassificationRecord[],
        sources: SourceRecord[],
        changes: ChangeRecord[],
        globalChanges: ChangeRecord[],
        idMap: IdMapRecord[]
    ): void {
        const arraysValid = Array.isArray(companies)
            && Array.isArray(products)
            && Array.isArray(investments)
            && Array.isArray(classifications)
            && Array.isArray(sources)
            && Array.isArray(changes)
            && Array.isArray(globalChanges)
            && Array.isArray(idMap);
        if (!arraysValid
            || companies.length !== this.expectedCompanyCount
            || products.length !== this.expectedProductCount
            || investments.length !== this.expectedInvestmentCount
            || classifications.length !== this.expectedCompanyCount
            || sources.length !== this.expectedSourceCount
            || changes.length + globalChanges.length !== 222
            || globalChanges.length !== 12
            || idMap.length !== this.expectedCompanyCount) {
            throw new Error('데이터 건수가 v0.3 검증 기준과 일치하지 않습니다.');
        }

        this.assertUnique(companies, (company) => company.id, '기업 ID');
        this.assertUnique(companies, (company) => company.researchId, '조사 기업 ID');
        this.assertUnique(products, (product) => product.productId, '제품 ID');
        this.assertUnique(investments, (investment) => investment.investmentId, '투자 ID');
        this.assertUnique(sources, (source) => source.sourceId, '출처 ID');
        this.assertUnique([...changes, ...globalChanges], (change) => change.changeId, '변경 ID');

        const companyIds = new Set(companies.map((company) => company.id));
        const researchIds = new Set(companies.map((company) => company.researchId));
        const sourceIds = new Set(sources.map((source) => source.sourceId));
        const hasBrokenCompanyLink = [...products, ...investments, ...classifications, ...sources, ...changes]
            .some((record) => record.companyId !== null && !companyIds.has(record.companyId));
        const hasBrokenResearchLink = [...products, ...investments, ...classifications, ...sources, ...changes]
            .some((record) => record.researchCompanyId !== null && !researchIds.has(record.researchCompanyId));
        const referencedSourceIds = [
            ...companies.flatMap((company) => company.researchSourceIds || []),
            ...products.flatMap((product) => product.sourceIds || []),
            ...investments.flatMap((investment) => investment.sourceIds || []),
            ...classifications.flatMap((classification) => classification.sourceIds || []),
            ...changes.flatMap((change) => change.sourceIds || [])
        ];
        if (hasBrokenCompanyLink || hasBrokenResearchLink || referencedSourceIds.some((id) => !sourceIds.has(id))) {
            throw new Error('기업 또는 출처 연결에 실패한 데이터가 있습니다.');
        }

        const mappingIsValid = idMap.every((mapping) => {
            const company = companies.find((item) => item.id === mapping.id);
            return company
                && company.researchId === mapping.researchId
                && company.companyName === mapping.companyName
                && mapping.matchedBy.includes('companyName')
                && mapping.matchedBy.includes('officialHomepageHost');
        });
        if (!mappingIsValid || companies.some((company) => !this.isValidCompany(company))) {
            throw new Error('기존 기업과 v0.3 기업의 대응이 올바르지 않습니다.');
        }
        if (investments.some((investment) => investment.roundAmountValue === 0 && !/\b0\b/.test(investment.roundAmountRaw || ''))) {
            throw new Error('금액 미공개 항목이 0으로 변환되었습니다.');
        }
    }

    private assertUnique<T>(records: T[], value: (record: T) => string, label: string): void {
        const ids = records.map(value);
        if (ids.some((id) => !id) || new Set(ids).size !== ids.length) {
            throw new Error(`${label}가 비어 있거나 중복되었습니다.`);
        }
    }

    private sortCompanies(): void {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        this.filteredCompanies = [...this.filteredCompanies].sort((first, second) => {
            let result: number;
            if (this.sortKey === 'developmentStage') {
                result = this.stageRank(first.developmentStage) - this.stageRank(second.developmentStage);
            } else {
                result = first[this.sortKey].localeCompare(second[this.sortKey], 'ko-KR', { numeric: true });
            }
            if (result === 0) result = first.companyName.localeCompare(second.companyName, 'ko-KR', { numeric: true });
            return result * direction;
        });
    }

    private stageRank(stage: string): number {
        return this.developmentStageOrder[stage] ?? Number.MAX_SAFE_INTEGER;
    }

    private companySearchValues(company: Company): string[] {
        return [
            company.companyName, company.researchId, company.industry, company.industryDetail, company.region,
            company.location, company.headquartersAddress, company.coreTechnology, company.mainProduct,
            company.targetDisease, company.productType, company.developmentStatus, company.regulatoryStatus,
            company.technologyMechanism, company.technologyApplications, company.technologyDifferentiation,
            company.mainBusiness, company.commercializationStage, company.screeningClassification
        ];
    }

    private productSearchValues(product: ProductRecord): string[] {
        return [
            product.productId, product.productName, product.purpose, product.targetCondition, product.applicationArea,
            product.technologyMechanism, product.developmentStageRaw, product.regulatoryName, product.regulatoryStatus
        ];
    }

    private normalizeSearch(value: unknown): string {
        return String(value ?? '').trim().toLocaleLowerCase('ko-KR');
    }

    private formatMonetaryValue(value: number | null, currency: string | null, unit: string | null, raw: string | null): string {
        if (value === null || value === undefined) return raw && raw.trim() ? raw : '금액 미공개';
        const formatted = value.toLocaleString('ko-KR', { maximumFractionDigits: 6 });
        const normalizedCurrency = (currency || '').trim();
        const normalizedUnit = (unit || '').trim();
        if (normalizedCurrency === 'KRW' && (normalizedUnit === '원' || normalizedUnit === '억원' || normalizedUnit === '백만원')) {
            return `${formatted}${normalizedUnit}`;
        }
        if (normalizedCurrency === 'USD' && /^(USD|달러)$/.test(normalizedUnit)) return `USD ${formatted}`;
        if (normalizedCurrency === 'USD' && /^(백만|million)$/i.test(normalizedUnit)) return `USD ${formatted} million`;
        if (normalizedUnit && normalizedUnit !== normalizedCurrency) {
            const separator = /^[a-z]/i.test(normalizedUnit) ? ' ' : '';
            return `${normalizedCurrency ? `${normalizedCurrency} ` : ''}${formatted}${separator}${normalizedUnit}`;
        }
        return `${normalizedCurrency ? `${normalizedCurrency} ` : ''}${formatted}`;
    }

    private buildSearchWorkbook(companies: Company[]): ExportSheet[] {
        return [
            this.companyListSheet('기업 목록', companies),
            this.productsSheet(companies),
            this.investmentsSheet(companies),
            this.sourcesSheet(companies),
            this.changesSheet(companies)
        ];
    }

    private buildComparisonWorkbook(companies: Company[]): ExportSheet[] {
        const comparisonRows: ExportValue[][] = [
            ['소재 지역', ...companies.map((company) => company.location)],
            ['기술 차별성', ...companies.map((company) => company.technologyDifferentiation)],
            ['주요 제품·제품별 개발단계', ...companies.map((company) => this.productComparison(company))],
            ['제품별 인허가 상태', ...companies.map((company) => this.regulatoryComparison(company))],
            ['사업화 단계', ...companies.map((company) => company.commercializationStage)],
            ['상장 여부·시장', ...companies.map((company) => `${company.listingStatus} · ${company.listingMarket}`)],
            ['공식 기업유형', ...companies.map((company) => company.companyType)],
            ['투자탐색용 분류', ...companies.map((company) => company.screeningClassification)],
            ['공개 투자·자금조달 기록', ...companies.map((company) => this.fundingComparison(company))],
            ['출처·자료 기준시점', ...companies.map((company) => this.sourceBasisComparison(company))]
        ];
        return [
            {
                name: '기업 비교',
                headers: ['비교 항목', ...companies.map((company) => company.companyName)],
                rows: comparisonRows,
                widths: [25, ...companies.map(() => 48)]
            },
            this.companyListSheet('기업 정보', companies),
            this.productsSheet(companies),
            this.investmentsSheet(companies),
            this.sourcesSheet(companies)
        ];
    }

    private companyListSheet(name: string, companies: Company[]): ExportSheet {
        return {
            name,
            headers: [
                '기존 기업ID', '조사 기업ID', '기업명', '설립연도', '권역', '본사 주소', '산업분야', '핵심 기술',
                '주요 제품', '기존 요약 단계', '개발 현황', '인허가 현황', '기술 작동 방식', '기술 적용 분야',
                '기존·대체 방식 대비 차이', '공개 성능·검증 결과', '특허·논문·기술이전 근거', '기업 주장·외부 확인 구분',
                '주력 사업', '사업화 단계', '사업화 범주', '상장 여부', '상장시장', '중소기업', '벤처기업', '공식 기업유형',
                '투자탐색용 분류안', '탐색용 분류 근거', '제품 수', '제품별 개발단계 요약', '제품별 인허가 요약',
                '공개 투자·자금조달 기록(구조화)', '출처 신뢰도', '정보 완성도', '조사 확인일', '추가 확인 필요사항',
                '공식 홈페이지', '기업유형 확인 URL'
            ],
            rows: companies.map((company) => [
                company.id, company.researchId, company.companyName, company.foundedYear, company.region,
                company.headquartersAddress, company.industryDetail, company.coreTechnology, company.mainProduct,
                company.developmentStage, company.developmentStatus, company.regulatoryStatus,
                company.technologyMechanism, company.technologyApplications, company.technologyDifferentiation,
                company.technologyPerformance, this.displayEvidence(company.technologyEvidence), company.technologyClaimBoundary,
                company.mainBusiness, company.commercializationStage, this.businessStageCategory(company), company.listingStatus,
                company.listingMarket, company.smeStatus, company.ventureStatus, company.companyType,
                company.screeningClassification, company.screeningClassificationBasis, company.productCount,
                company.productStageSummary, company.productRegulatorySummary, this.fundingComparison(company),
                company.sourceReliability, company.dataCompleteness, company.researchCheckedAt, company.researchFollowUpItems,
                this.hyperlink(company.officialHomepage, '공식 홈페이지'), this.hyperlink(company.companyTypeSourceUrl, '자격 확인')
            ]),
            widths: [15, 15, 22, 11, 12, 34, 28, 38, 34, 16, 42, 42, 48, 38, 48, 52, 48, 48, 42, 44, 17, 12, 12, 12, 12, 34, 38, 48, 10, 55, 55, 48, 13, 13, 15, 52, 20, 20]
        };
    }

    private productsSheet(companies: Company[]): ExportSheet {
        const products = this.recordsInCompanyOrder(companies, this.products, (product) => product.companyId);
        return {
            name: '제품·파이프라인',
            headers: [
                '제품ID', '기존 기업ID', '조사 기업ID', '기업명', '제품·파이프라인명', '사용 목적', '대상 질환·적용 분야',
                '기술 작동 방식', '적용 분야', '기존·대체 방식 대비 차이', '공개 성능·검증 결과', '특허·논문·기술이전 근거',
                '기업 주장·외부 확인 구분', '개발단계(원문)', '개발단계 범주', '단계 기준시점', '허가 국가', '담당 기관',
                '인허가 구분', '인허가 범주', '허가·인증 명칭', '번호', '일자', '상태', '출처ID', '출처 URL', '추가 확인 필요사항'
            ],
            rows: products.map((product) => [
                product.productId, product.companyId, product.researchCompanyId, product.companyName, product.productName,
                product.purpose, product.targetCondition, product.technologyMechanism, product.applicationArea,
                product.differentiation, product.performanceEvidence, this.displayEvidence(product.ipEvidence), product.claimBoundary,
                product.developmentStageRaw, this.productStageCategory(product), product.stageAsOf, product.regulatoryCountry,
                product.regulatoryAgency, product.regulatoryType, this.regulatoryCategory(product), product.regulatoryName,
                product.regulatoryNumber, product.regulatoryDate, product.regulatoryStatus, product.sourceIds.join('; '),
                this.hyperlink(product.sourceUrls[0] || '', '원문 열기'), product.followUpItems
            ]),
            widths: [17, 15, 15, 22, 32, 36, 28, 48, 36, 48, 52, 48, 48, 34, 17, 24, 20, 25, 30, 18, 34, 20, 20, 42, 30, 18, 52]
        };
    }

    private investmentsSheet(companies: Company[]): ExportSheet {
        const investments = this.recordsInCompanyOrder(companies, this.investments, (investment) => investment.companyId);
        return {
            name: '투자·자금조달',
            headers: [
                '투자ID', '기존 기업ID', '조사 기업ID', '기업명', '발표일', '실제 투자시점', '라운드',
                '회차 금액(숫자)', '통화', '단위', '회차 금액 표시', '회차 금액 원문', '참여 투자기관',
                '누적 금액(숫자)', '누적 통화', '누적 단위', '누적 금액 원문·구분 메모',
                '기업가치(숫자)', '기업가치 통화', '기업가치 단위', '기업가치 원문',
                '자금 성격(표준)', '자금 성격 원문', '자료 확보 상태', '중복 통합·구분 메모', '출처ID', '출처 URL'
            ],
            rows: investments.map((investment) => [
                investment.investmentId, investment.companyId, investment.researchCompanyId, investment.companyName,
                investment.announcementDate, investment.actualInvestmentDate, investment.round,
                investment.roundAmountValue, investment.currency, investment.amountUnit, this.formatAmount(investment),
                investment.roundAmountRaw, investment.investors, investment.cumulativeAmountValue,
                investment.cumulativeCurrency, investment.cumulativeUnit, investment.cumulativeAmountRaw,
                investment.valuationValue, investment.valuationCurrency, investment.valuationUnit, investment.valuationRaw,
                investment.fundingType, investment.fundingTypeRaw, investment.availabilityStatus, investment.deduplicationNote,
                investment.sourceIds.join('; '), this.hyperlink(investment.sourceUrls[0] || '', '원문 열기')
            ]),
            widths: [17, 15, 15, 22, 22, 18, 28, 22, 10, 10, 24, 28, 42, 22, 12, 12, 45, 22, 12, 12, 38, 24, 30, 28, 52, 30, 18]
        };
    }

    private sourcesSheet(companies: Company[]): ExportSheet {
        const sources = this.recordsInCompanyOrder(companies, this.sources, (source) => source.companyId);
        return {
            name: '출처 목록',
            headers: [
                '출처ID', '기존·추가', '기존 기업ID', '조사 기업ID', '기업명', '항목 분류', '연결 대상ID',
                '자료 제목', '발행기관', '자료 유형', '발표일', '조사 확인일', '원문 링크', '접근·본문 확인 결과',
                '근거 핵심내용', '근거 구분', '출처 신뢰도'
            ],
            rows: sources.map((source) => [
                source.sourceId, source.provenance, source.companyId, source.researchCompanyId, source.companyName,
                source.category, source.linkedTargetIds.join('; '), source.title, source.publisher, source.sourceType,
                source.publicationDate, source.checkedAt, this.hyperlink(source.url, source.title), source.accessResult,
                source.evidenceSummary, source.evidenceType, source.reliability
            ]),
            widths: [17, 22, 15, 15, 22, 30, 30, 46, 26, 22, 20, 15, 42, 45, 56, 30, 13]
        };
    }

    private changesSheet(companies: Company[]): ExportSheet {
        const changes = this.recordsInCompanyOrder(companies, this.changes, (change) => change.companyId || '');
        return {
            name: '변경·보완',
            headers: [
                '내역ID', '기존 기업ID', '조사 기업ID', '기업명', '구분', '항목', '이전 값', 'v0.3 값·보완내용',
                '수정·보완 사유', '출처ID', '상태', '추가 확인 필요사항', '대시보드 반영 제안'
            ],
            rows: changes.map((change) => [
                change.changeId, change.companyId || '', change.researchCompanyId || '', change.companyName,
                change.category, change.field, change.previousValue, change.newValue, change.reason,
                change.sourceIds.join('; '), change.status, change.followUpItems, change.dashboardSuggestion
            ]),
            widths: [15, 15, 15, 22, 20, 24, 42, 52, 48, 32, 18, 52, 42]
        };
    }

    private async downloadWorkbook(filename: string, exportSheets: ExportSheet[]): Promise<void> {
        const filterRanges: Record<string, string> = {};
        const sheets: Sheet<File | Blob | ArrayBuffer>[] = exportSheets.map((sheet) => {
            const data = this.sheetData(sheet);
            filterRanges[sheet.name] = `A1:${this.columnName(sheet.headers.length)}${data.length}`;
            return {
                data,
                sheet: sheet.name,
                columns: sheet.widths.map((width) => ({ width })),
                stickyRowsCount: 1,
                stickyColumnsCount: 1,
                showGridLines: false,
                orientation: 'landscape',
                zoomScale: 0.85
            };
        });
        const autoFilterFeature: Feature<File | Blob | ArrayBuffer> = {
            files: {
                transform: {
                    'xl/worksheets/sheet{id}.xml': {
                        transform: (content, options) => {
                            const range = filterRanges[options.sheet || ''];
                            if (!range || content.includes('<autoFilter')) return content;
                            return content.replace('</sheetData>', `</sheetData><autoFilter ref="${range}"/>`);
                        }
                    }
                }
            }
        };

        await writeXlsxFile(sheets, {
            fontFamily: 'Arial',
            fontSize: 10,
            features: [autoFilterFeature]
        }).toFile(filename);
    }

    private sheetData(sheet: ExportSheet): SheetData {
        const rows: ExportValue[][] = [sheet.headers, ...sheet.rows];
        return rows.map((row, rowIndex) => row.map((value) => {
            const baseStyle = {
                height: rowIndex === 0 ? 30 : 44,
                alignVertical: 'top' as const,
                wrap: true,
                borderColor: '#D9E2EC',
                bottomBorderStyle: 'thin' as const,
                rightBorderStyle: 'thin' as const
            };
            if (this.isHyperlinkCell(value) && this.isHttpUrl(value.url)) {
                return {
                    ...baseStyle,
                    value: `HYPERLINK("${this.formulaText(value.url)}","${this.formulaText(value.label)}")`,
                    type: 'Formula' as const,
                    textColor: '#0563C1',
                    textDecoration: { underline: true as const },
                    ...(rowIndex % 2 === 0 ? { backgroundColor: '#F5F8FC' } : {})
                };
            }
            if (typeof value === 'number') {
                return {
                    ...baseStyle,
                    value,
                    type: Number,
                    format: '#,##0.######',
                    align: 'right' as const,
                    ...(rowIndex % 2 === 0 ? { backgroundColor: '#F5F8FC' } : {})
                };
            }
            return {
                ...baseStyle,
                value: this.spreadsheetSafeText(this.display(value)),
                type: String,
                format: '@',
                ...(rowIndex === 0
                    ? {
                        backgroundColor: '#163E6C',
                        textColor: '#FFFFFF',
                        fontWeight: 'bold' as const,
                        align: 'center' as const,
                        alignVertical: 'center' as const
                    }
                    : rowIndex % 2 === 0
                        ? { backgroundColor: '#F5F8FC' }
                        : {})
            };
        }));
    }

    private searchCsvRows(companies: Company[]): string[][] {
        const headers = [
            '기업ID', '조사 기업ID', '기업명', '설립연도', '상장 여부·시장', '공식 기업유형', '투자탐색용 분류안',
            '주요 산업군', '핵심 기술', '기술 차별성', '제품·파이프라인 전체', '제품별 개발단계 전체',
            '제품별 인허가 전체', '사업화 단계', '투자·자금조달 이력 전체', '출처 제목·URL·기준시점 전체',
            '자료 확인일', '정보 완성도', '추가 확인 필요사항'
        ];
        return [headers, ...companies.map((company) => [
            company.id,
            company.researchId,
            company.companyName,
            company.foundedYear,
            `${company.listingStatus} · ${company.listingMarket}`,
            company.companyType,
            company.screeningClassification,
            company.industry,
            company.coreTechnology,
            company.technologyDifferentiation,
            this.productsFor(company).map((product) => `${product.productId}: ${product.productName} — ${product.purpose}`).join('\n'),
            this.productComparison(company),
            this.regulatoryComparison(company),
            company.commercializationStage,
            this.investmentsFor(company).map((investment) => [
                investment.investmentId,
                investment.actualInvestmentDate || investment.announcementDate,
                investment.round,
                this.formatAmount(investment),
                investment.fundingType,
                investment.availabilityStatus,
                investment.deduplicationNote,
                investment.sourceUrls.join(' | ')
            ].join(' · ')).join('\n'),
            this.sourcesFor(company).map((source) => `${source.sourceId}: ${source.title} · ${source.checkedAt} · ${source.url}`).join('\n'),
            company.researchCheckedAt,
            company.dataCompleteness,
            company.researchFollowUpItems
        ])];
    }

    private comparisonCsvRows(companies: Company[]): string[][] {
        return [
            ['비교 항목', ...companies.map((company) => company.companyName)],
            ['기업ID', ...companies.map((company) => company.researchId)],
            ['소재 지역', ...companies.map((company) => company.location)],
            ['기술 차별성', ...companies.map((company) => company.technologyDifferentiation)],
            ['제품·파이프라인', ...companies.map((company) => this.productsFor(company).map((product) => `${product.productId}: ${product.productName}`).join('\n'))],
            ['제품별 개발단계', ...companies.map((company) => this.productComparison(company))],
            ['제품별 인허가', ...companies.map((company) => this.regulatoryComparison(company))],
            ['사업화 단계', ...companies.map((company) => company.commercializationStage)],
            ['상장·기업 분류', ...companies.map((company) => `${company.listingStatus} · ${company.listingMarket}\n공식: ${company.companyType}\n탐색용: ${company.screeningClassification}`)],
            ['투자·자금조달 이력', ...companies.map((company) => this.fundingComparison(company))],
            ['출처·기준시점', ...companies.map((company) => this.sourcesFor(company).map((source) => `${source.sourceId}: ${source.title} · ${source.checkedAt} · ${source.url}`).join('\n'))]
        ];
    }

    private downloadCsv(filename: string, rows: string[][]): void {
        const csv = rows
            .map((row) => row.map((value) => this.csvCell(this.spreadsheetSafeText(this.display(value)))).join(','))
            .join('\r\n');
        const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        URL.revokeObjectURL(url);
    }

    private csvCell(value: string): string {
        return `"${value.replace(/"/g, '""')}"`;
    }

    private hyperlink(url: string, label: string): HyperlinkCell | string {
        return this.isHttpUrl(url) ? { url, label } : this.display(url);
    }

    private isHyperlinkCell(value: ExportValue): value is HyperlinkCell {
        return typeof value === 'object' && value !== null && 'url' in value && 'label' in value;
    }

    private formulaText(value: string): string {
        return value.replace(/"/g, '""');
    }

    private recordsInCompanyOrder<T>(companies: Company[], records: T[], companyId: (record: T) => string): T[] {
        const order = new Map(companies.map((company, index) => [company.id, index]));
        return records
            .filter((record) => order.has(companyId(record)))
            .map((record, originalIndex) => ({ record, originalIndex }))
            .sort((first, second) => {
                const companyDifference = (order.get(companyId(first.record)) || 0) - (order.get(companyId(second.record)) || 0);
                return companyDifference || first.originalIndex - second.originalIndex;
            })
            .map(({ record }) => record);
    }

    private columnName(columnCount: number): string {
        let value = columnCount;
        let name = '';
        while (value > 0) {
            value -= 1;
            name = String.fromCharCode(65 + (value % 26)) + name;
            value = Math.floor(value / 26);
        }
        return name;
    }

    private spreadsheetSafeText(value: string): string {
        return /^[=+\-@]/.test(value) ? `'${value}` : value;
    }

    private today(): string {
        return new Date().toISOString().slice(0, 10);
    }

    private uniqueCompanyValues(field: keyof Company): string[] {
        return this.uniqueStrings(this.companies.map((company) => String(company[field] ?? '')));
    }

    private uniqueStrings(values: Array<string | null | undefined>): string[] {
        return [...new Set(values.map((value) => String(value ?? '').trim()).filter(Boolean))]
            .sort((first, second) => first.localeCompare(second, 'ko-KR', { numeric: true }));
    }

    private isHttpUrl(value: string | null | undefined): value is string {
        return typeof value === 'string' && /^https?:\/\//i.test(value);
    }

    private isValidCompany(company: Company): boolean {
        const requiredStringFields: Array<keyof Company> = [
            'id', 'researchId', 'companyName', 'foundedYear', 'region', 'location', 'headquartersAddress',
            'industry', 'industryDetail', 'coreTechnology', 'mainProduct', 'targetDisease', 'productType',
            'developmentStage', 'developmentStatus', 'regulatoryStatus', 'officialHomepage', 'sourceCheckedAt',
            'sourceReliability', 'dataCompleteness', 'technologyMechanism', 'technologyDifferentiation',
            'commercializationStage', 'screeningClassification', 'researchCheckedAt'
        ];
        return Boolean(company)
            && requiredStringFields.every((field) => typeof company[field] === 'string' && String(company[field]).trim().length > 0)
            && Array.isArray(company.researchSourceIds)
            && Object.prototype.hasOwnProperty.call(this.developmentStageOrder, company.developmentStage);
    }
}

export default PageDashboardComponent;